PJQ.constants = {
    customerService: {
        getPhone: function () {
            return PJQ.helpers.formatHelpers.formatPhoneNumber('8772199777');
        },
        getEmail: function () {
            if (PJQ.app.options.isPanteraApp) {
                return 'customerservice@panteratools.com';
            }
            return 'contactus@jobplanner.com'
        }
    },
    services: {
        ORIGIN: "ORIGIN",
        API: "API",
        FILES: "FILES",
        APIv2: "APIv2"
    },
    panteraPortalId: 4,
    publicUserId: 39,
    publicLogoURL: "https://app.panteratools.com/images/pantera_app_logo.png",
    countries: ['us', 'ca'],
    internationalCountries: [{
        name: "Afghanistan",
        states: ["Badakhshan", "Badghis", "Baghlan", "Balkh", "Bamyan", "Daykundi", "Farah", "Faryab", "Ghazni", "Ghōr", "Helmand", "Herat", "Jowzjan", "Kabul", "Kandahar", "Kapisa", "Khost", "Kunar", "Kunduz Province", "Laghman", "Logar", "Nangarhar", "Nimruz", "Nuristan", "Paktia", "Paktika", "Panjshir", "Parwan", "Samangan", "Sar-e Pol", "Takhar", "Urozgan", "Zabul"]
    }, {
        name: "Aland Islands",
        states: ["Brändö", "Eckerö", "Finström", "Föglö", "Geta", "Hammarland", "Jomala", "Kökar", "Kumlinge", "Lemland", "Lumparland", "Mariehamn", "Saltvik", "Sottunga", "Sund", "Vårdö"]
    }, {
        name: "Albania",
        states: ["Berat County", "Berat District", "Bulqizë District", "Delvinë District", "Devoll District", "Dibër County", "Dibër District", "Durrës County", "Durrës District", "Elbasan County", "Fier County", "Fier District", "Gjirokastër County", "Gjirokastër District", "Gramsh District", "Has District", "Kavajë District", "Kolonjë District", "Korçë County", "Korçë District", "Krujë District", "Kuçovë District", "Kukës County", "Kukës District", "Kurbin District", "Lezhë County", "Lezhë District", "Librazhd District", "Lushnjë District", "Malësi e Madhe District", "Mallakastër District", "Mat District", "Mirditë District", "Peqin District", "Përmet District", "Pogradec District", "Pukë District", "Sarandë District", "Shkodër County", "Shkodër District", "Skrapar District", "Tepelenë District", "Tirana County", "Tirana District", "Tropojë District", "Vlorë County", "Vlorë District"]
    }, {
        name: "Algeria",
        states: ["Adrar", "Aïn Defla", "Aïn Témouchent", "Algiers", "Annaba", "Batna", "Béchar", "Béjaïa", "Béni Abbès", "Biskra", "Blida", "Bordj Baji Mokhtar", "Bordj Bou Arréridj", "Bouïra", "Boumerdès", "Chlef", "Constantine", "Djanet", "Djelfa", "El Bayadh", "El M'ghair", "El Menia", "El Oued", "El Tarf", "Ghardaïa", "Guelma", "Illizi", "In Guezzam", "In Salah", "Jijel", "Khenchela", "Laghouat", "M'Sila", "Mascara", "Médéa", "Mila", "Mostaganem", "Naama", "Oran", "Ouargla", "Ouled Djellal", "Oum El Bouaghi", "Relizane", "Saïda", "Sétif", "Sidi Bel Abbès", "Skikda", "Souk Ahras", "Tamanghasset", "Tébessa", "Tiaret", "Timimoun", "Tindouf", "Tipasa", "Tissemsilt", "Tizi Ouzou", "Tlemcen", "Touggourt"]
    }, {name: "American Samoa", states: []}, {
        name: "Andorra",
        states: ["Andorra la Vella", "Canillo", "Encamp", "Escaldes-Engordany", "La Massana", "Ordino", "Sant Julià de Lòria"]
    }, {
        name: "Angola",
        states: ["Bengo Province", "Benguela Province", "Bié Province", "Cabinda Province", "Cuando Cubango Province", "Cuanza Norte Province", "Cuanza Sul", "Cunene Province", "Huambo Province", "Huíla Province", "Luanda Province", "Lunda Norte Province", "Lunda Sul Province", "Malanje Province", "Moxico Province", "Uíge Province", "Zaire Province"]
    }, {
        name: "Anguilla",
        states: ["Blowing Point", "East End", "George Hill", "Island Harbour", "North Hill", "North Side", "Sandy Ground", "Sandy Hill", "South Hill", "Stoney Ground", "The Farrington", "The Quarter", "The Valley", "West End"]
    }, {name: "Antarctica", states: []}, {
        name: "Antigua and Barbuda",
        states: ["Barbuda", "Redonda", "Saint George Parish", "Saint John Parish", "Saint Mary Parish", "Saint Paul Parish", "Saint Peter Parish", "Saint Philip Parish"]
    }, {
        name: "Argentina",
        states: ["Buenos Aires", "Catamarca", "Chaco", "Chubut", "Ciudad Autónoma de Buenos Aires", "Córdoba", "Corrientes", "Entre Ríos", "Formosa", "Jujuy", "La Pampa", "La Rioja", "Mendoza", "Misiones", "Neuquén", "Río Negro", "Salta", "San Juan", "San Luis", "Santa Cruz", "Santa Fe", "Santiago del Estero", "Tierra del Fuego", "Tucumán"]
    }, {
        name: "Armenia",
        states: ["Aragatsotn Region", "Ararat Province", "Armavir Region", "Gegharkunik Province", "Kotayk Region", "Lori Region", "Shirak Region", "Syunik Province", "Tavush Region", "Vayots Dzor Region", "Yerevan"]
    }, {
        name: "Aruba",
        states: ["Noord", "Oranjestad East", "Oranjestad West", "Paradera", "San Nicolaas Noord", "San Nicolaas Zuid", "Santa Cruz", "Savaneta"]
    }, {
        name: "Australia",
        states: ["Australian Capital Territory", "New South Wales", "Northern Territory", "Queensland", "South Australia", "Tasmania", "Victoria", "Western Australia"]
    }, {
        name: "Austria",
        states: ["Burgenland", "Carinthia", "Lower Austria", "Salzburg", "Styria", "Tyrol", "Upper Austria", "Vienna", "Vorarlberg"]
    }, {
        name: "Azerbaijan",
        states: ["Absheron District", "Agdam District", "Agdash District", "Aghjabadi District", "Agstafa District", "Agsu District", "Astara District", "Babek District", "Baku", "Balakan District", "Barda District", "Beylagan District", "Bilasuvar District", "Dashkasan District", "Fizuli District", "Ganja", "Gədəbəy", "Gobustan District", "Goranboy District", "Goychay", "Goygol District", "Hajigabul District", "Imishli District", "Ismailli District", "Jabrayil District", "Jalilabad District", "Julfa District", "Kalbajar District", "Kangarli District", "Khachmaz District", "Khizi District", "Khojali District", "Kurdamir District", "Lachin District", "Lankaran", "Lankaran District", "Lerik District", "Martuni", "Masally District", "Mingachevir", "Nakhchivan Autonomous Republic", "Neftchala District", "Oghuz District", "Ordubad District", "Qabala District", "Qakh District", "Qazakh District", "Quba District", "Qubadli District", "Qusar District", "Saatly District", "Sabirabad District", "Sadarak District", "Salyan District", "Samukh District", "Shabran District", "Shahbuz District", "Shaki", "Shaki District", "Shamakhi District", "Shamkir District", "Sharur District", "Shirvan", "Shusha District", "Siazan District", "Sumqayit", "Tartar District", "Tovuz District", "Ujar District", "Yardymli District", "Yevlakh", "Yevlakh District", "Zangilan District", "Zaqatala District", "Zardab District"]
    }, {name: "Bahrain", states: ["Capital", "Central", "Muharraq", "Northern", "Southern"]}, {
        name: "Bangladesh",
        states: ["Barisal ", "Chittagong ", "Dhaka ", "Khulna ", "Mymensingh ", "Rajshahi ", "Rangpur ", "Sylhet "]
    }, {
        name: "Barbados",
        states: ["Christ Church", "Saint Andrew", "Saint George", "Saint James", "Saint John", "Saint Joseph", "Saint Lucy", "Saint Michael", "Saint Peter", "Saint Philip", "Saint Thomas"]
    }, {
        name: "Belarus",
        states: ["Brest Region", "Gomel Region", "Grodno Region", "Minsk", "Minsk Region", "Mogilev Region", "Vitebsk Region"]
    }, {
        name: "Belgium",
        states: ["Antwerp", "Brussels-Capital Region", "East Flanders", "Flanders", "Flemish Brabant", "Hainaut", "Liège", "Limburg", "Luxembourg", "Namur", "Wallonia", "Walloon Brabant", "West Flanders"]
    }, {
        name: "Belize",
        states: ["Belize District", "Cayo District", "Corozal District", "Orange Walk District", "Stann Creek District", "Toledo District"]
    }, {
        name: "Benin",
        states: ["Alibori Department", "Atakora Department", "Atlantique Department", "Borgou Department", "Collines Department", "Donga Department", "Kouffo Department", "Littoral Department", "Mono Department", "Ouémé Department", "Plateau Department", "Zou Department"]
    }, {
        name: "Bermuda",
        states: ["Devonshire", "Hamilton", "Paget", "Pembroke", "Saint George's", "Sandys", "Smith's", "Southampton", "Warwick"]
    }, {
        name: "Bhutan",
        states: ["Bumthang ", "Chukha ", "Dagana ", "Gasa ", "Haa ", "Lhuntse ", "Mongar ", "Paro ", "Pemagatshel ", "Punakha ", "Samdrup Jongkhar ", "Samtse ", "Sarpang ", "Thimphu ", "Trashi Yangtse\t", "Trashigang ", "Trongsa ", "Tsirang ", "Wangdue Phodrang ", "Zhemgang "]
    }, {
        name: "Bolivia",
        states: ["Beni Department", "Chuquisaca Department", "Cochabamba Department", "La Paz Department", "Oruro Department", "Pando Department", "Potosí Department", "Santa Cruz Department", "Tarija Department"]
    }, {
        name: "Bonaire, Sint Eustatius and Saba",
        states: ["Bonaire", "Saba", "Sint Eustatius"]
    }, {
        name: "Bosnia and Herzegovina",
        states: ["Bosnian Podrinje Canton", "Brčko District", "Canton 10", "Central Bosnia Canton", "Federation of Bosnia and Herzegovina", "Herzegovina-Neretva Canton", "Posavina Canton", "Republika Srpska", "Sarajevo Canton", "Tuzla Canton", "Una-Sana Canton", "West Herzegovina Canton", "Zenica-Doboj Canton"]
    }, {
        name: "Botswana",
        states: ["Central District", "Ghanzi District", "Kgalagadi District", "Kgatleng District", "Kweneng District", "Ngamiland", "North-East District", "North-West District", "South-East District", "Southern District"]
    }, {name: "Bouvet Island", states: []}, {
        name: "Brazil",
        states: ["Acre", "Alagoas", "Amapá", "Amazonas", "Bahia", "Ceará", "Distrito Federal", "Espírito Santo", "Goiás", "Maranhão", "Mato Grosso", "Mato Grosso do Sul", "Minas Gerais", "Pará", "Paraíba", "Paraná", "Pernambuco", "Piauí", "Rio de Janeiro", "Rio Grande do Norte", "Rio Grande do Sul", "Rondônia", "Roraima", "Santa Catarina", "São Paulo", "Sergipe", "Tocantins"]
    }, {name: "British Indian Ocean Territory", states: []}, {
        name: "Brunei",
        states: ["Belait District", "Brunei-Muara District", "Temburong District", "Tutong District"]
    }, {
        name: "Bulgaria",
        states: ["Blagoevgrad Province", "Burgas Province", "Dobrich Province", "Gabrovo Province", "Haskovo Province", "Kardzhali Province", "Kyustendil Province", "Lovech Province", "Montana Province", "Pazardzhik Province", "Pernik Province", "Pleven Province", "Plovdiv Province", "Razgrad Province", "Ruse Province", "Shumen", "Silistra Province", "Sliven Province", "Smolyan Province", "Sofia City Province", "Sofia Province", "Stara Zagora Province", "Targovishte Province", "Varna Province", "Veliko Tarnovo Province", "Vidin Province", "Vratsa Province", "Yambol Province"]
    }, {
        name: "Burkina Faso",
        states: ["Balé Province", "Bam Province", "Banwa Province", "Bazèga Province", "Boucle du Mouhoun Region", "Bougouriba Province", "Boulgou", "Cascades Region", "Centre", "Centre-Est Region", "Centre-Nord Region", "Centre-Ouest Region", "Centre-Sud Region", "Comoé Province", "Est Region", "Ganzourgou Province", "Gnagna Province", "Gourma Province", "Hauts-Bassins Region", "Houet Province", "Ioba Province", "Kadiogo Province", "Kénédougou Province", "Komondjari Province", "Kompienga Province", "Kossi Province", "Koulpélogo Province", "Kouritenga Province", "Kourwéogo Province", "Léraba Province", "Loroum Province", "Mouhoun", "Nahouri Province", "Namentenga Province", "Nayala Province", "Nord Region, Burkina Faso", "Noumbiel Province", "Oubritenga Province", "Oudalan Province", "Passoré Province", "Plateau-Central Region", "Poni Province", "Sahel Region", "Sanguié Province", "Sanmatenga Province", "Séno Province", "Sissili Province", "Soum Province", "Sourou Province", "Sud-Ouest Region", "Tapoa Province", "Tuy Province", "Yagha Province", "Yatenga Province", "Ziro Province", "Zondoma Province", "Zoundwéogo Province"]
    }, {
        name: "Burundi",
        states: ["Bubanza Province", "Bujumbura Mairie Province", "Bujumbura Rural Province", "Bururi Province", "Cankuzo Province", "Cibitoke Province", "Gitega Province", "Karuzi Province", "Kayanza Province", "Kirundo Province", "Makamba Province", "Muramvya Province", "Muyinga Province", "Mwaro Province", "Ngozi Province", "Rumonge Province", "Rutana Province", "Ruyigi Province"]
    }, {
        name: "Cambodia",
        states: ["Banteay Meanchey", "Battambang", "Kampong Cham", "Kampong Chhnang", "Kampong Speu", "Kampong Thom", "Kampot", "Kandal", "Kep", "Koh Kong", "Kratie", "Mondulkiri", "Oddar Meanchey", "Pailin", "Phnom Penh", "Preah Vihear", "Prey Veng", "Pursat", "Ratanakiri", "Siem Reap", "Sihanoukville", "Stung Treng", "Svay Rieng", "Takeo"]
    }, {
        name: "Cameroon",
        states: ["Adamawa", "Centre", "East", "Far North", "Littoral", "North", "Northwest", "South", "Southwest", "West"]
    }, {
        name: "Cape Verde",
        states: ["Barlavento Islands", "Boa Vista", "Brava", "Maio Municipality", "Mosteiros", "Paul", "Porto Novo", "Praia", "Ribeira Brava Municipality", "Ribeira Grande", "Ribeira Grande de Santiago", "Sal", "Santa Catarina", "Santa Catarina do Fogo", "Santa Cruz", "São Domingos", "São Filipe", "São Lourenço dos Órgãos", "São Miguel", "São Vicente", "Sotavento Islands", "Tarrafal", "Tarrafal de São Nicolau"]
    }, {
        name: "Cayman Islands",
        states: ["Cayman Brac", "Grand Cayman", "Little Cayman"]
    }, {
        name: "Central African Republic",
        states: ["Bamingui-Bangoran Prefecture", "Bangui", "Basse-Kotto Prefecture", "Haut-Mbomou Prefecture", "Haute-Kotto Prefecture", "Kémo Prefecture", "Lobaye Prefecture", "Mambéré-Kadéï", "Mbomou Prefecture", "Nana-Grébizi Economic Prefecture", "Nana-Mambéré Prefecture", "Ombella-M'Poko Prefecture", "Ouaka Prefecture", "Ouham Prefecture", "Ouham-Pendé Prefecture", "Sangha-Mbaéré", "Vakaga Prefecture"]
    }, {
        name: "Chad",
        states: ["Bahr el Gazel", "Batha", "Borkou", "Chari-Baguirmi", "Ennedi-Est", "Ennedi-Ouest", "Guéra", "Hadjer-Lamis", "Kanem", "Lac", "Logone Occidental", "Logone Oriental", "Mandoul", "Mayo-Kebbi Est", "Mayo-Kebbi Ouest", "Moyen-Chari", "N'Djamena", "Ouaddaï", "Salamat", "Sila", "Tandjilé", "Tibesti", "Wadi Fira"]
    }, {
        name: "Chile",
        states: ["Aisén del General Carlos Ibañez del Campo", "Antofagasta", "Arica y Parinacota", "Atacama", "Biobío", "Coquimbo", "La Araucanía", "Libertador General Bernardo O'Higgins", "Los Lagos", "Los Ríos", "Magallanes y de la Antártica Chilena", "Maule", "Ñuble", "Región Metropolitana de Santiago", "Tarapacá", "Valparaíso"]
    }, {
        name: "China",
        states: ["Anhui", "Beijing", "Chongqing", "Fujian", "Gansu", "Guangdong", "Guangxi Zhuang", "Guizhou", "Hainan", "Hebei", "Heilongjiang", "Henan", "Hong Kong SAR", "Hubei", "Hunan", "Inner Mongolia", "Jiangsu", "Jiangxi", "Jilin", "Liaoning", "Macau SAR", "Ningxia Huizu", "Qinghai", "Shaanxi", "Shandong", "Shanghai", "Shanxi", "Sichuan", "Taiwan", "Tianjin", "Xinjiang", "Xizang", "Yunnan", "Zhejiang"]
    }, {name: "Christmas Island", states: []}, {name: "Cocos (Keeling) Islands", states: []}, {
        name: "Colombia",
        states: ["Amazonas", "Antioquia", "Arauca", "Archipiélago de San Andrés, Providencia y Santa Catalina", "Atlántico", "Bogotá D.C.", "Bolívar", "Boyacá", "Caldas", "Caquetá", "Casanare", "Cauca", "Cesar", "Chocó", "Córdoba", "Cundinamarca", "Guainía", "Guaviare", "Huila", "La Guajira", "Magdalena", "Meta", "Nariño", "Norte de Santander", "Putumayo", "Quindío", "Risaralda", "Santander", "Sucre", "Tolima", "Valle del Cauca", "Vaupés", "Vichada"]
    }, {name: "Comoros", states: ["Anjouan", "Grande Comore", "Mohéli"]}, {
        name: "Congo",
        states: ["Bouenza Department", "Brazzaville", "Cuvette Department", "Cuvette-Ouest Department", "Kouilou Department", "Lékoumou Department", "Likouala Department", "Niari Department", "Plateaux Department", "Pointe-Noire", "Pool Department", "Sangha Department"]
    }, {name: "Cook Islands", states: []}, {
        name: "Costa Rica",
        states: ["Alajuela Province", "Guanacaste Province", "Heredia Province", "Limón Province", "Provincia de Cartago", "Puntarenas Province", "San José Province"]
    }, {
        name: "Cote D'Ivoire (Ivory Coast)",
        states: ["Abidjan", "Agnéby", "Bafing Region", "Bas-Sassandra District", "Bas-Sassandra Region", "Comoé District", "Denguélé District", "Denguélé Region", "Dix-Huit Montagnes", "Fromager", "Gôh-Djiboua District", "Haut-Sassandra", "Lacs District", "Lacs Region", "Lagunes District", "Lagunes region", "Marahoué Region", "Montagnes District", "Moyen-Cavally", "Moyen-Comoé", "N'zi-Comoé", "Sassandra-Marahoué District", "Savanes Region", "Sud-Bandama", "Sud-Comoé", "Vallée du Bandama District", "Vallée du Bandama Region", "Woroba District", "Worodougou", "Yamoussoukro", "Zanzan Region"]
    }, {
        name: "Croatia",
        states: ["Bjelovar-Bilogora", "Brod-Posavina", "Dubrovnik-Neretva", "Istria", "Karlovac", "Koprivnica-Križevci", "Krapina-Zagorje", "Lika-Senj", "Međimurje", "Osijek-Baranja", "Požega-Slavonia", "Primorje-Gorski Kotar", "Šibenik-Knin", "Sisak-Moslavina", "Split-Dalmatia", "Varaždin", "Virovitica-Podravina", "Vukovar-Syrmia", "Zadar", "Zagreb", "Zagreb"]
    }, {
        name: "Cuba",
        states: ["Artemisa Province", "Camagüey Province", "Ciego de Ávila Province", "Cienfuegos Province", "Granma Province", "Guantánamo Province", "Havana Province", "Holguín Province", "Isla de la Juventud", "Las Tunas Province", "Matanzas Province", "Mayabeque Province", "Pinar del Río Province", "Sancti Spíritus Province", "Santiago de Cuba Province", "Villa Clara Province"]
    }, {name: "Curaçao", states: []}, {
        name: "Cyprus",
        states: ["Famagusta District (Mağusa)", "Kyrenia District (Keryneia)", "Larnaca District (Larnaka)", "Limassol District (Leymasun)", "Nicosia District (Lefkoşa)", "Paphos District (Pafos)"]
    }, {
        name: "Czech Republic",
        states: ["Benešov", "Beroun", "Blansko", "Břeclav", "Brno-město", "Brno-venkov", "Bruntál", "Česká Lípa", "České Budějovice", "Český Krumlov", "Cheb", "Chomutov", "Chrudim", "Děčín", "Domažlice", "Frýdek-Místek", "Havlíčkův Brod", "Hodonín", "Hradec Králové", "Jablonec nad Nisou", "Jeseník", "Jičín", "Jihlava", "Jihočeský kraj", "Jihomoravský kraj", "Jindřichův Hradec", "Karlovarský kraj", "Karlovy Vary", "Karviná", "Kladno", "Klatovy", "Kolín", "Kraj Vysočina", "Královéhradecký kraj", "Kroměříž", "Kutná Hora", "Liberec", "Liberecký kraj", "Litoměřice", "Louny", "Mělník", "Mladá Boleslav", "Moravskoslezský kraj", "Most", "Náchod", "Nový Jičín", "Nymburk", "Olomouc", "Olomoucký kraj", "Opava", "Ostrava-město", "Pardubice", "Pardubický kraj", "Pelhřimov", "Písek", "Plzeň-jih", "Plzeň-město", "Plzeň-sever", "Plzeňský kraj", "Prachatice", "Praha-východ", "Praha-západ", "Praha, Hlavní město", "Přerov", "Příbram", "Prostějov", "Rakovník", "Rokycany", "Rychnov nad Kněžnou", "Semily", "Sokolov", "Strakonice", "Středočeský kraj", "Šumperk", "Svitavy", "Tábor", "Tachov", "Teplice", "Třebíč", "Trutnov", "Uherské Hradiště", "Ústecký kraj", "Ústí nad Labem", "Ústí nad Orlicí", "Vsetín", "Vyškov", "Žďár nad Sázavou", "Zlín", "Zlínský kraj", "Znojmo"]
    }, {
        name: "Democratic Republic of the Congo",
        states: ["Bas-Uélé", "Équateur", "Haut-Katanga", "Haut-Lomami", "Haut-Uélé", "Ituri", "Kasaï", "Kasaï Central", "Kasaï Oriental", "Kinshasa", "Kongo Central", "Kwango", "Kwilu", "Lomami", "Lualaba", "Mai-Ndombe", "Maniema", "Mongala", "Nord-Kivu", "Nord-Ubangi", "Sankuru", "Sud-Kivu", "Sud-Ubangi", "Tanganyika", "Tshopo", "Tshuapa"]
    }, {
        name: "Denmark",
        states: ["Capital Region of Denmark", "Central Denmark Region", "North Denmark Region", "Region of Southern Denmark", "Region Zealand"]
    }, {
        name: "Djibouti",
        states: ["Ali Sabieh Region", "Arta Region", "Dikhil Region", "Djibouti", "Obock Region", "Tadjourah Region"]
    }, {
        name: "Dominica",
        states: ["Saint Andrew Parish", "Saint David Parish", "Saint George Parish", "Saint John Parish", "Saint Joseph Parish", "Saint Luke Parish", "Saint Mark Parish", "Saint Patrick Parish", "Saint Paul Parish", "Saint Peter Parish"]
    }, {
        name: "Dominican Republic",
        states: ["Azua Province", "Baoruco Province", "Barahona Province", "Dajabón Province", "Distrito Nacional", "Duarte Province", "El Seibo Province", "Espaillat Province", "Hato Mayor Province", "Hermanas Mirabal Province", "Independencia", "La Altagracia Province", "La Romana Province", "La Vega Province", "María Trinidad Sánchez Province", "Monseñor Nouel Province", "Monte Cristi Province", "Monte Plata Province", "Pedernales Province", "Peravia Province", "Puerto Plata Province", "Samaná Province", "San Cristóbal Province", "San José de Ocoa Province", "San Juan Province", "San Pedro de Macorís", "Sánchez Ramírez Province", "Santiago Province", "Santiago Rodríguez Province", "Santo Domingo Province", "Valverde Province"]
    }, {
        name: "Ecuador",
        states: ["Azuay", "Bolívar", "Cañar", "Carchi", "Chimborazo", "Cotopaxi", "El Oro", "Esmeraldas", "Galápagos", "Guayas", "Imbabura", "Loja", "Los Ríos", "Manabí", "Morona-Santiago", "Napo", "Orellana", "Pastaza", "Pichincha", "Santa Elena", "Santo Domingo de los Tsáchilas", "Sucumbíos", "Tungurahua", "Zamora Chinchipe"]
    }, {
        name: "Egypt",
        states: ["Alexandria", "Aswan", "Asyut", "Beheira", "Beni Suef", "Cairo", "Dakahlia", "Damietta", "Faiyum", "Gharbia", "Giza", "Ismailia", "Kafr el-Sheikh", "Luxor", "Matrouh", "Minya", "Monufia", "New Valley", "North Sinai", "Port Said", "Qalyubia", "Qena", "Red Sea", "Sharqia", "Sohag", "South Sinai", "Suez"]
    }, {
        name: "El Salvador",
        states: ["Ahuachapán Department", "Cabañas Department", "Chalatenango Department", "Cuscatlán Department", "La Libertad Department", "La Paz Department", "La Unión Department", "Morazán Department", "San Miguel Department", "San Salvador Department", "San Vicente Department", "Santa Ana Department", "Sonsonate Department", "Usulután Department"]
    }, {
        name: "Equatorial Guinea",
        states: ["Annobón Province", "Bioko Norte Province", "Bioko Sur Province", "Centro Sur Province", "Insular Region", "Kié-Ntem Province", "Litoral Province", "Río Muni", "Wele-Nzas Province"]
    }, {
        name: "Eritrea",
        states: ["Anseba Region", "Debub Region", "Gash-Barka Region", "Maekel Region", "Northern Red Sea Region", "Southern Red Sea Region"]
    }, {
        name: "Estonia",
        states: ["Harju County", "Hiiu County", "Ida-Viru County", "Järva County", "Jõgeva County", "Lääne County", "Lääne-Viru County", "Pärnu County", "Põlva County", "Rapla County", "Saare County", "Tartu County", "Valga County", "Viljandi County", "Võru County"]
    }, {
        name: "Eswatini",
        states: ["Hhohho District", "Lubombo District", "Manzini District", "Shiselweni District"]
    }, {
        name: "Ethiopia",
        states: ["Addis Ababa", "Afar Region", "Amhara Region", "Benishangul-Gumuz Region", "Dire Dawa", "Gambela Region", "Harari Region", "Oromia Region", "Somali Region", "Southern Nations, Nationalities, and Peoples' Region", "Tigray Region"]
    }, {name: "Falkland Islands", states: []}, {
        name: "Faroe Islands",
        states: ["Eysturoy", "Northern Isles", "Sandoy", "Streymoy", "Suðuroy", "Vágar"]
    }, {
        name: "Fiji Islands",
        states: ["Ba", "Bua", "Cakaudrove", "Central Division", "Eastern Division", "Kadavu", "Lau", "Lomaiviti", "Macuata", "Nadroga-Navosa", "Naitasiri", "Namosi", "Northern Division", "Ra", "Rewa", "Rotuma", "Serua", "Tailevu", "Western Division"]
    }, {
        name: "Finland",
        states: ["Åland Islands", "Central Finland", "Central Ostrobothnia", "Finland Proper", "Kainuu", "Kymenlaakso", "Lapland", "North Karelia", "Northern Ostrobothnia", "Northern Savonia", "Ostrobothnia", "Päijänne Tavastia", "Pirkanmaa", "Satakunta", "South Karelia", "Southern Ostrobothnia", "Southern Savonia", "Tavastia Proper", "Uusimaa"]
    }, {
        name: "France",
        states: ["Ain", "Aisne", "Allier", "Alpes-de-Haute-Provence", "Alpes-Maritimes", "Alsace", "Ardèche", "Ardennes", "Ariège", "Aube", "Aude", "Auvergne-Rhône-Alpes", "Aveyron", "Bas-Rhin", "Bouches-du-Rhône", "Bourgogne-Franche-Comté", "Bretagne", "Calvados", "Cantal", "Centre-Val de Loire", "Charente", "Charente-Maritime", "Cher", "Clipperton", "Corrèze", "Corse", "Corse-du-Sud", "Côte-d'Or", "Côtes-d'Armor", "Creuse", "Deux-Sèvres", "Dordogne", "Doubs", "Drôme", "Essonne", "Eure", "Eure-et-Loir", "Finistère", "French Guiana", "French Polynesia", "French Southern and Antarctic Lands", "Gard", "Gers", "Gironde", "Grand-Est", "Guadeloupe", "Haut-Rhin", "Haute-Corse", "Haute-Garonne", "Haute-Loire", "Haute-Marne", "Haute-Saône", "Haute-Savoie", "Haute-Vienne", "Hautes-Alpes", "Hautes-Pyrénées", "Hauts-de-France", "Hauts-de-Seine", "Hérault", "Île-de-France", "Ille-et-Vilaine", "Indre", "Indre-et-Loire", "Isère", "Jura", "La Réunion", "Landes", "Loir-et-Cher", "Loire", "Loire-Atlantique", "Loiret", "Lot", "Lot-et-Garonne", "Lozère", "Maine-et-Loire", "Manche", "Marne", "Martinique", "Mayenne", "Mayotte", "Métropole de Lyon", "Meurthe-et-Moselle", "Meuse", "Morbihan", "Moselle", "Nièvre", "Nord", "Normandie", "Nouvelle-Aquitaine", "Occitanie", "Oise", "Orne", "Paris", "Pas-de-Calais", "Pays-de-la-Loire", "Provence-Alpes-Côte-d’Azur", "Puy-de-Dôme", "Pyrénées-Atlantiques", "Pyrénées-Orientales", "Rhône", "Saint Pierre and Miquelon", "Saint-Barthélemy", "Saint-Martin", "Saône-et-Loire", "Sarthe", "Savoie", "Seine-et-Marne", "Seine-Maritime", "Seine-Saint-Denis", "Somme", "Tarn", "Tarn-et-Garonne", "Territoire de Belfort", "Val-d'Oise", "Val-de-Marne", "Var", "Vaucluse", "Vendée", "Vienne", "Vosges", "Wallis and Futuna", "Yonne", "Yvelines"]
    }, {name: "French Guiana", states: []}, {
        name: "French Polynesia",
        states: []
    }, {name: "French Southern Territories", states: []}, {
        name: "Gabon",
        states: ["Estuaire Province", "Haut-Ogooué Province", "Moyen-Ogooué Province", "Ngounié Province", "Nyanga Province", "Ogooué-Ivindo Province", "Ogooué-Lolo Province", "Ogooué-Maritime Province", "Woleu-Ntem Province"]
    }, {
        name: "Georgia",
        states: ["Abkhazia", "Adjara", "Guria", "Imereti", "Kakheti", "Khelvachauri Municipality", "Kvemo Kartli", "Mtskheta-Mtianeti", "Racha-Lechkhumi and Kvemo Svaneti", "Samegrelo-Zemo Svaneti", "Samtskhe-Javakheti", "Senaki Municipality", "Shida Kartli", "Tbilisi"]
    }, {
        name: "Germany",
        states: ["Baden-Württemberg", "Bavaria", "Berlin", "Brandenburg", "Bremen", "Hamburg", "Hessen", "Lower Saxony", "Mecklenburg-Vorpommern", "North Rhine-Westphalia", "Rhineland-Palatinate", "Saarland", "Saxony", "Saxony-Anhalt", "Schleswig-Holstein", "Thuringia"]
    }, {
        name: "Ghana",
        states: ["Ahafo", "Ashanti", "Bono", "Bono East", "Central", "Eastern", "Greater Accra", "North East", "Northern", "Oti", "Savannah", "Upper East", "Upper West", "Volta", "Western", "Western North"]
    }, {name: "Gibraltar", states: []}, {
        name: "Greece",
        states: ["Achaea Regional Unit", "Aetolia-Acarnania Regional Unit", "Arcadia Prefecture", "Argolis Regional Unit", "Attica Region", "Boeotia Regional Unit", "Central Greece Region", "Central Macedonia", "Chania Regional Unit", "Corfu Prefecture", "Corinthia Regional Unit", "Crete Region", "Drama Regional Unit", "East Attica Regional Unit", "East Macedonia and Thrace", "Epirus Region", "Euboea", "Grevena Prefecture", "Imathia Regional Unit", "Ioannina Regional Unit", "Ionian Islands Region", "Karditsa Regional Unit", "Kastoria Regional Unit", "Kefalonia Prefecture", "Kilkis Regional Unit", "Kozani Prefecture", "Laconia", "Larissa Prefecture", "Lefkada Regional Unit", "Pella Regional Unit", "Peloponnese Region", "Phthiotis Prefecture", "Preveza Prefecture", "Serres Prefecture", "South Aegean", "Thessaloniki Regional Unit", "West Greece Region", "West Macedonia Region"]
    }, {name: "Greenland", states: []}, {
        name: "Grenada",
        states: ["Carriacou and Petite Martinique", "Saint Andrew Parish", "Saint David Parish", "Saint George Parish", "Saint John Parish", "Saint Mark Parish", "Saint Patrick Parish"]
    }, {name: "Guadeloupe", states: []}, {
        name: "Guam",
        states: ["Agana Heights", "Asan-Maina", "Barrigada", "Chalan Pago-Ordot", "Dededo", "Hågat", "Hagåtña", "Inarajan (Inalåhan)", "Mangilao", "Merizo (Malesso)", "Mongmong-Toto-Maite", "Piti", "Santa Rita (Sånta Rita-Sumai)", "Sinajana", "Talofofo (Talo'fo'fo)", "Tamuning", "Umatac (Humåtak)", "Yigo", "Yona"]
    }, {
        name: "Guatemala",
        states: ["Alta Verapaz ", "Baja Verapaz ", "Chimaltenango ", "Chiquimula ", "El Progreso ", "Escuintla ", "Guatemala ", "Huehuetenango ", "Izabal ", "Jalapa ", "Jutiapa ", "Petén ", "Quetzaltenango ", "Quiché ", "Retalhuleu ", "Sacatepéquez ", "San Marcos ", "Santa Rosa ", "Sololá ", "Suchitepéquez ", "Totonicapán ", "Zacapa"]
    }, {name: "Guernsey and Alderney", states: []}, {
        name: "Guinea",
        states: ["Beyla Prefecture", "Boffa Prefecture", "Boké Prefecture", "Boké Region", "Conakry", "Coyah Prefecture", "Dabola Prefecture", "Dalaba Prefecture", "Dinguiraye Prefecture", "Dubréka Prefecture", "Faranah Prefecture", "Forécariah Prefecture", "Fria Prefecture", "Gaoual Prefecture", "Guéckédou Prefecture", "Kankan Prefecture", "Kankan Region", "Kérouané Prefecture", "Kindia Prefecture", "Kindia Region", "Kissidougou Prefecture", "Koubia Prefecture", "Koundara Prefecture", "Kouroussa Prefecture", "Labé Prefecture", "Labé Region", "Lélouma Prefecture", "Lola Prefecture", "Macenta Prefecture", "Mali Prefecture", "Mamou Prefecture", "Mamou Region", "Mandiana Prefecture", "Nzérékoré Prefecture", "Nzérékoré Region", "Pita Prefecture", "Siguiri Prefecture", "Télimélé Prefecture", "Tougué Prefecture", "Yomou Prefecture"]
    }, {
        name: "Guinea-Bissau",
        states: ["Bafatá", "Biombo Region", "Bolama Region", "Cacheu Region", "Gabú Region", "Leste Province", "Norte Province", "Oio Region", "Quinara Region", "Sul Province", "Tombali Region"]
    }, {
        name: "Guyana",
        states: ["Barima-Waini", "Cuyuni-Mazaruni", "Demerara-Mahaica", "East Berbice-Corentyne", "Essequibo Islands-West Demerara", "Mahaica-Berbice", "Pomeroon-Supenaam", "Potaro-Siparuni", "Upper Demerara-Berbice", "Upper Takutu-Upper Essequibo"]
    }, {
        name: "Haiti",
        states: ["Artibonite", "Centre", "Grand'Anse", "Nippes", "Nord", "Nord-Est", "Nord-Ouest", "Ouest", "Sud", "Sud-Est"]
    }, {name: "Heard Island and McDonald Islands", states: []}, {
        name: "Honduras",
        states: ["Atlántida Department", "Bay Islands Department", "Choluteca Department", "Colón Department", "Comayagua Department", "Copán Department", "Cortés Department", "El Paraíso Department", "Francisco Morazán Department", "Gracias a Dios Department", "Intibucá Department", "La Paz Department", "Lempira Department", "Ocotepeque Department", "Olancho Department", "Santa Bárbara Department", "Valle Department", "Yoro Department"]
    }, {
        name: "Hong Kong S.A.R.",
        states: ["Central and Western", "Eastern", "Islands", "Kowloon City", "Kwai Tsing", "Kwun Tong", "North", "Sai Kung", "Sha Tin", "Sham Shui Po", "Southern", "Tai Po", "Tsuen Wan", "Tuen Mun", "Wan Chai", "Wong Tai Sin", "Yau Tsim Mong", "Yuen Long"]
    }, {
        name: "Hungary",
        states: ["Bács-Kiskun", "Baranya", "Békés", "Békéscsaba", "Borsod-Abaúj-Zemplén", "Budapest", "Csongrád County", "Debrecen", "Dunaújváros", "Eger", "Érd", "Fejér County", "Győr", "Győr-Moson-Sopron County", "Hajdú-Bihar County", "Heves County", "Hódmezővásárhely", "Jász-Nagykun-Szolnok County", "Kaposvár", "Kecskemét", "Komárom-Esztergom", "Miskolc", "Nagykanizsa", "Nógrád County", "Nyíregyháza", "Pécs", "Pest County", "Salgótarján", "Somogy County", "Sopron", "Szabolcs-Szatmár-Bereg County", "Szeged", "Székesfehérvár", "Szekszárd", "Szolnok", "Szombathely", "Tatabánya", "Tolna County", "Vas County", "Veszprém", "Veszprém County", "Zala County", "Zalaegerszeg"]
    }, {
        name: "Iceland",
        states: ["Capital Region", "Eastern Region", "Northeastern Region", "Northwestern Region", "Southern Peninsula Region", "Southern Region", "Western Region", "Westfjords"]
    }, {
        name: "India",
        states: ["Andaman and Nicobar Islands", "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chandigarh", "Chhattisgarh", "Dadra and Nagar Haveli and Daman and Diu", "Delhi", "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jammu and Kashmir", "Jharkhand", "Karnataka", "Kerala", "Ladakh", "Lakshadweep", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Puducherry", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal"]
    }, {
        name: "Indonesia",
        states: ["Aceh", "Bali", "Banten", "Bengkulu", "DI Yogyakarta", "DKI Jakarta", "Gorontalo", "Jambi", "Jawa Barat", "Jawa Tengah", "Jawa Timur", "Kalimantan Barat", "Kalimantan Selatan", "Kalimantan Tengah", "Kalimantan Timur", "Kalimantan Utara", "Kepulauan Bangka Belitung", "Kepulauan Riau", "Lampung", "Maluku", "Maluku Utara", "Nusa Tenggara Barat", "Nusa Tenggara Timur", "Papua", "Papua Barat", "Papua Barat Daya", "Papua Pegunungan", "Papua Selatan", "Papua Tengah", "Riau", "Sulawesi Barat", "Sulawesi Selatan", "Sulawesi Tengah", "Sulawesi Tenggara", "Sulawesi Utara", "Sumatera Barat", "Sumatera Selatan", "Sumatera Utara"]
    }, {
        name: "Iran",
        states: ["Alborz", "Ardabil", "Bushehr", "Chaharmahal and Bakhtiari", "East Azerbaijan", "Fars", "Gilan", "Golestan", "Hamadan", "Hormozgan", "Ilam", "Isfahan", "Kerman", "Kermanshah", "Khuzestan", "Kohgiluyeh and Boyer-Ahmad", "Kurdistan", "Lorestan", "Markazi", "Mazandaran", "North Khorasan", "Qazvin", "Qom", "Razavi Khorasan", "Semnan", "Sistan and Baluchestan", "South Khorasan", "Tehran", "West Azarbaijan", "Yazd", "Zanjan"]
    }, {
        name: "Iraq",
        states: ["Al Anbar", "Al Muthanna", "Al-Qādisiyyah", "Babylon", "Baghdad", "Basra", "Dhi Qar", "Diyala", "Dohuk", "Erbil", "Karbala", "Kirkuk", "Maysan", "Najaf", "Nineveh", "Saladin", "Sulaymaniyah", "Wasit"]
    }, {
        name: "Ireland",
        states: ["Carlow", "Cavan", "Clare", "Connacht", "Cork", "Donegal", "Dublin", "Galway", "Kerry", "Kildare", "Kilkenny", "Laois", "Leinster", "Limerick", "Longford", "Louth", "Mayo", "Meath", "Monaghan", "Munster", "Offaly", "Roscommon", "Sligo", "Tipperary", "Ulster", "Waterford", "Westmeath", "Wexford", "Wicklow"]
    }, {
        name: "Israel",
        states: ["Central District", "Haifa District", "Jerusalem District", "Northern District", "Southern District", "Tel Aviv District"]
    }, {
        name: "Italy",
        states: ["Abruzzo", "Agrigento", "Alessandria", "Ancona", "Aosta Valley", "Apulia", "Ascoli Piceno", "Asti", "Avellino", "Barletta-Andria-Trani", "Basilicata", "Belluno", "Benevento", "Bergamo", "Biella", "Brescia", "Brindisi", "Calabria", "Caltanissetta", "Campania", "Campobasso", "Caserta", "Catanzaro", "Chieti", "Como", "Cosenza", "Cremona", "Crotone", "Cuneo", "Emilia-Romagna", "Enna", "Fermo", "Ferrara", "Foggia", "Forlì-Cesena", "Friuli–Venezia Giulia", "Frosinone", "Gorizia", "Grosseto", "Imperia", "Isernia", "L'Aquila", "La Spezia", "Latina", "Lazio", "Lecce", "Lecco", "Liguria", "Livorno", "Lodi", "Lombardy", "Lucca", "Macerata", "Mantua", "Marche", "Massa and Carrara", "Matera", "Medio Campidano", "Modena", "Molise", "Monza and Brianza", "Novara", "Nuoro", "Oristano", "Padua", "Palermo", "Parma", "Pavia", "Perugia", "Pesaro and Urbino", "Pescara", "Piacenza", "Piedmont", "Pisa", "Pistoia", "Pordenone", "Potenza", "Prato", "Ragusa", "Ravenna", "Reggio Emilia", "Rieti", "Rimini", "Rovigo", "Salerno", "Sardinia", "Sassari", "Savona", "Sicily", "Siena", "Siracusa", "Sondrio", "South Sardinia", "Taranto", "Teramo", "Terni", "Trapani", "Trentino-South Tyrol", "Treviso", "Trieste", "Tuscany", "Udine", "Umbria", "Varese", "Veneto", "Verbano-Cusio-Ossola", "Vercelli", "Verona", "Vibo Valentia", "Vicenza", "Viterbo"]
    }, {
        name: "Jamaica",
        states: ["Clarendon Parish", "Hanover Parish", "Kingston Parish", "Manchester Parish", "Portland Parish", "Saint Andrew", "Saint Ann Parish", "Saint Catherine Parish", "Saint Elizabeth Parish", "Saint James Parish", "Saint Mary Parish", "Saint Thomas Parish", "Trelawny Parish", "Westmoreland Parish"]
    }, {
        name: "Japan",
        states: ["Aichi Prefecture", "Akita Prefecture", "Aomori Prefecture", "Chiba Prefecture", "Ehime Prefecture", "Fukui Prefecture", "Fukuoka Prefecture", "Fukushima Prefecture", "Gifu Prefecture", "Gunma Prefecture", "Hiroshima Prefecture", "Hokkaidō Prefecture", "Hyōgo Prefecture", "Ibaraki Prefecture", "Ishikawa Prefecture", "Iwate Prefecture", "Kagawa Prefecture", "Kagoshima Prefecture", "Kanagawa Prefecture", "Kōchi Prefecture", "Kumamoto Prefecture", "Kyōto Prefecture", "Mie Prefecture", "Miyagi Prefecture", "Miyazaki Prefecture", "Nagano Prefecture", "Nagasaki Prefecture", "Nara Prefecture", "Niigata Prefecture", "Ōita Prefecture", "Okayama Prefecture", "Okinawa Prefecture", "Ōsaka Prefecture", "Saga Prefecture", "Saitama Prefecture", "Shiga Prefecture", "Shimane Prefecture", "Shizuoka Prefecture", "Tochigi Prefecture", "Tokushima Prefecture", "Tokyo", "Tottori Prefecture", "Toyama Prefecture", "Wakayama Prefecture", "Yamagata Prefecture", "Yamaguchi Prefecture", "Yamanashi Prefecture"]
    }, {
        name: "Jersey",
        states: ["Grouville", "St Brelade", "St Clement", "St Helier", "St John", "St Lawrence", "St Martin", "St Mary", "St Ouen", "St Peter", "St Saviour", "Trinity"]
    }, {
        name: "Jordan",
        states: ["Ajloun", "Amman", "Aqaba", "Balqa", "Irbid", "Jerash", "Karak", "Ma'an", "Madaba", "Mafraq", "Tafilah", "Zarqa"]
    }, {
        name: "Kazakhstan",
        states: ["Akmola Region", "Aktobe Region", "Almaty", "Almaty Region", "Atyrau Region", "Baikonur", "East Kazakhstan Region", "Jambyl Region", "Karaganda Region", "Kostanay Region", "Kyzylorda Region", "Mangystau Region", "North Kazakhstan Region", "Nur-Sultan", "Pavlodar Region", "Turkestan Region", "West Kazakhstan Province"]
    }, {
        name: "Kenya",
        states: ["Baringo", "Bomet", "Bungoma", "Busia", "Elgeyo-Marakwet", "Embu", "Garissa", "Homa Bay", "Isiolo", "Kajiado", "Kakamega", "Kericho", "Kiambu", "Kilifi", "Kirinyaga", "Kisii", "Kisumu", "Kitui", "Kwale", "Laikipia", "Lamu", "Machakos", "Makueni", "Mandera", "Marsabit", "Meru", "Migori", "Mombasa", "Murang'a", "Nairobi City", "Nakuru", "Nandi", "Narok", "Nyamira", "Nyandarua", "Nyeri", "Samburu", "Siaya", "Taita–Taveta", "Tana River", "Tharaka-Nithi", "Trans Nzoia", "Turkana", "Uasin Gishu", "Vihiga", "Wajir", "West Pokot"]
    }, {name: "Kiribati", states: ["Gilbert Islands", "Line Islands", "Phoenix Islands"]}, {
        name: "Kosovo",
        states: ["Đakovica District (Gjakove)", "Gjilan District", "Kosovska Mitrovica District", "Peć District", "Pristina (Priştine)", "Prizren District", "Uroševac District (Ferizaj)"]
    }, {
        name: "Kuwait",
        states: ["Al Ahmadi", "Al Farwaniyah", "Al Jahra", "Capital", "Hawalli", "Mubarak Al-Kabeer"]
    }, {
        name: "Kyrgyzstan",
        states: ["Batken Region", "Bishkek", "Chuy Region", "Issyk-Kul Region", "Jalal-Abad Region", "Naryn Region", "Osh", "Osh Region", "Talas Region"]
    }, {
        name: "Laos",
        states: ["Attapeu Province", "Bokeo Province", "Bolikhamsai Province", "Champasak Province", "Houaphanh Province", "Khammouane Province", "Luang Namtha Province", "Luang Prabang Province", "Oudomxay Province", "Phongsaly Province", "Sainyabuli Province", "Salavan Province", "Savannakhet Province", "Sekong Province", "Vientiane Prefecture", "Vientiane Province", "Xaisomboun", "Xaisomboun Province", "Xiangkhouang Province"]
    }, {
        name: "Latvia",
        states: ["Aglona Municipality", "Aizkraukle Municipality", "Aizpute Municipality", "Aknīste Municipality", "Aloja Municipality", "Alsunga Municipality", "Alūksne Municipality", "Amata Municipality", "Ape Municipality", "Auce Municipality", "Babīte Municipality", "Baldone Municipality", "Baltinava Municipality", "Balvi Municipality", "Bauska Municipality", "Beverīna Municipality", "Brocēni Municipality", "Burtnieki Municipality", "Carnikava Municipality", "Cēsis Municipality", "Cesvaine Municipality", "Cibla Municipality", "Dagda Municipality", "Daugavpils", "Daugavpils Municipality", "Dobele Municipality", "Dundaga Municipality", "Durbe Municipality", "Engure Municipality", "Ērgļi Municipality", "Garkalne Municipality", "Grobiņa Municipality", "Gulbene Municipality", "Iecava Municipality", "Ikšķile Municipality", "Ilūkste Municipality", "Inčukalns Municipality", "Jaunjelgava Municipality", "Jaunpiebalga Municipality", "Jaunpils Municipality", "Jēkabpils", "Jēkabpils Municipality", "Jelgava", "Jelgava Municipality", "Jūrmala", "Kandava Municipality", "Kārsava Municipality", "Ķegums Municipality", "Ķekava Municipality", "Kocēni Municipality", "Koknese Municipality", "Krāslava Municipality", "Krimulda Municipality", "Krustpils Municipality", "Kuldīga Municipality", "Lielvārde Municipality", "Liepāja", "Līgatne Municipality", "Limbaži Municipality", "Līvāni Municipality", "Lubāna Municipality", "Ludza Municipality", "Madona Municipality", "Mālpils Municipality", "Mārupe Municipality", "Mazsalaca Municipality", "Mērsrags Municipality", "Naukšēni Municipality", "Nereta Municipality", "Nīca Municipality", "Ogre Municipality", "Olaine Municipality", "Ozolnieki Municipality", "Pārgauja Municipality", "Pāvilosta Municipality", "Pļaviņas Municipality", "Preiļi Municipality", "Priekule Municipality", "Priekuļi Municipality", "Rauna Municipality", "Rēzekne", "Rēzekne Municipality", "Riebiņi Municipality", "Riga", "Roja Municipality", "Ropaži Municipality", "Rucava Municipality", "Rugāji Municipality", "Rūjiena Municipality", "Rundāle Municipality", "Sala Municipality", "Salacgrīva Municipality", "Salaspils Municipality", "Saldus Municipality", "Saulkrasti Municipality", "Sēja Municipality", "Sigulda Municipality", "Skrīveri Municipality", "Skrunda Municipality", "Smiltene Municipality", "Stopiņi Municipality", "Strenči Municipality", "Talsi Municipality", "Tērvete Municipality", "Tukums Municipality", "Vaiņode Municipality", "Valka Municipality", "Valmiera", "Varakļāni Municipality", "Vārkava Municipality", "Vecpiebalga Municipality", "Vecumnieki Municipality", "Ventspils", "Ventspils Municipality", "Viesīte Municipality", "Viļaka Municipality", "Viļāni Municipality", "Zilupe Municipality"]
    }, {
        name: "Lebanon",
        states: ["Akkar", "Baalbek-Hermel", "Beirut", "Beqaa", "Mount Lebanon", "Nabatieh", "North", "South"]
    }, {
        name: "Lesotho",
        states: ["Berea District", "Butha-Buthe District", "Leribe District", "Mafeteng District", "Maseru District", "Mohale's Hoek District", "Mokhotlong District", "Qacha's Nek District", "Quthing District", "Thaba-Tseka District"]
    }, {
        name: "Liberia",
        states: ["Bomi County", "Bong County", "Gbarpolu County", "Grand Bassa County", "Grand Cape Mount County", "Grand Gedeh County", "Grand Kru County", "Lofa County", "Margibi County", "Maryland County", "Montserrado County", "Nimba", "River Cess County", "River Gee County", "Sinoe County"]
    }, {
        name: "Libya",
        states: ["Al Wahat District", "Benghazi", "Derna District", "Ghat District", "Jabal al Akhdar", "Jabal al Gharbi District", "Jafara", "Jufra", "Kufra District", "Marj District", "Misrata District", "Murqub", "Murzuq District", "Nalut District", "Nuqat al Khams", "Sabha District", "Sirte District", "Tripoli District", "Wadi al Hayaa District", "Wadi al Shatii District", "Zawiya District"]
    }, {
        name: "Liechtenstein",
        states: ["Balzers", "Eschen", "Gamprin", "Mauren", "Planken", "Ruggell", "Schaan", "Schellenberg", "Triesen", "Triesenberg", "Vaduz"]
    }, {
        name: "Lithuania",
        states: ["Akmenė District Municipality", "Alytus City Municipality", "Alytus County", "Alytus District Municipality", "Birštonas Municipality", "Biržai District Municipality", "Druskininkai municipality", "Elektrėnai municipality", "Ignalina District Municipality", "Jonava District Municipality", "Joniškis District Municipality", "Jurbarkas District Municipality", "Kaišiadorys District Municipality", "Kalvarija municipality", "Kaunas City Municipality", "Kaunas County", "Kaunas District Municipality", "Kazlų Rūda municipality", "Kėdainiai District Municipality", "Kelmė District Municipality", "Klaipeda City Municipality", "Klaipėda County", "Klaipėda District Municipality", "Kretinga District Municipality", "Kupiškis District Municipality", "Lazdijai District Municipality", "Marijampolė County", "Marijampolė Municipality", "Mažeikiai District Municipality", "Molėtai District Municipality", "Neringa Municipality", "Pagėgiai municipality", "Pakruojis District Municipality", "Palanga City Municipality", "Panevėžys City Municipality", "Panevėžys County", "Panevėžys District Municipality", "Pasvalys District Municipality", "Plungė District Municipality", "Prienai District Municipality", "Radviliškis District Municipality", "Raseiniai District Municipality", "Rietavas municipality", "Rokiškis District Municipality", "Šakiai District Municipality", "Šalčininkai District Municipality", "Šiauliai City Municipality", "Šiauliai County", "Šiauliai District Municipality", "Šilalė District Municipality", "Šilutė District Municipality", "Širvintos District Municipality", "Skuodas District Municipality", "Švenčionys District Municipality", "Tauragė County", "Tauragė District Municipality", "Telšiai County", "Telšiai District Municipality", "Trakai District Municipality", "Ukmergė District Municipality", "Utena County", "Utena District Municipality", "Varėna District Municipality", "Vilkaviškis District Municipality", "Vilnius City Municipality", "Vilnius County", "Vilnius District Municipality", "Visaginas Municipality", "Zarasai District Municipality"]
    }, {
        name: "Luxembourg",
        states: ["Canton of Capellen", "Canton of Clervaux", "Canton of Diekirch", "Canton of Echternach", "Canton of Esch-sur-Alzette", "Canton of Grevenmacher", "Canton of Luxembourg", "Canton of Mersch", "Canton of Redange", "Canton of Remich", "Canton of Vianden", "Canton of Wiltz", "Diekirch District", "Grevenmacher District", "Luxembourg District"]
    }, {name: "Macau S.A.R.", states: []}, {
        name: "Madagascar",
        states: ["Antananarivo Province", "Antsiranana Province", "Fianarantsoa Province", "Mahajanga Province", "Toamasina Province", "Toliara Province"]
    }, {
        name: "Malawi",
        states: ["Balaka District", "Blantyre District", "Central Region", "Chikwawa District", "Chiradzulu District", "Chitipa district", "Dedza District", "Dowa District", "Karonga District", "Kasungu District", "Likoma District", "Lilongwe District", "Machinga District", "Mangochi District", "Mchinji District", "Mulanje District", "Mwanza District", "Mzimba District", "Nkhata Bay District", "Nkhotakota District", "Northern Region", "Nsanje District", "Ntcheu District", "Ntchisi District", "Phalombe District", "Rumphi District", "Salima District", "Southern Region", "Thyolo District", "Zomba District"]
    }, {
        name: "Malaysia",
        states: ["Johor", "Kedah", "Kelantan", "Kuala Lumpur", "Labuan", "Malacca", "Negeri Sembilan", "Pahang", "Penang", "Perak", "Perlis", "Putrajaya", "Sabah", "Sarawak", "Selangor", "Terengganu"]
    }, {
        name: "Maldives",
        states: ["Addu Atoll", "Alif Alif Atoll", "Alif Dhaal Atoll", "Central Province", "Dhaalu Atoll", "Faafu Atoll", "Gaafu Alif Atoll", "Gaafu Dhaalu Atoll", "Gnaviyani Atoll", "Haa Alif Atoll", "Haa Dhaalu Atoll", "Kaafu Atoll", "Laamu Atoll", "Lhaviyani Atoll", "Malé", "Meemu Atoll", "Noonu Atoll", "North Central Province", "North Province", "Raa Atoll", "Shaviyani Atoll", "South Central Province", "South Province", "Thaa Atoll", "Upper South Province", "Vaavu Atoll"]
    }, {
        name: "Mali",
        states: ["Bamako", "Gao Region", "Kayes Region", "Kidal Region", "Koulikoro Region", "Ménaka Region", "Mopti Region", "Ségou Region", "Sikasso Region", "Taoudénit Region", "Tombouctou Region"]
    }, {
        name: "Malta",
        states: ["Attard", "Balzan", "Birgu", "Birkirkara", "Birżebbuġa", "Cospicua", "Dingli", "Fgura", "Floriana", "Fontana", "Għajnsielem", "Għarb", "Għargħur", "Għasri", "Għaxaq", "Gudja", "Gżira", "Ħamrun", "Iklin", "Kalkara", "Kerċem", "Kirkop", "Lija", "Luqa", "Marsa", "Marsaskala", "Marsaxlokk", "Mdina", "Mellieħa", "Mġarr", "Mosta", "Mqabba", "Msida", "Mtarfa", "Munxar", "Nadur", "Naxxar", "Paola", "Pembroke", "Pietà", "Qala", "Qormi", "Qrendi", "Rabat", "San Ġwann", "San Lawrenz", "Sannat", "Santa Luċija", "Santa Venera", "Senglea", "Siġġiewi", "Sliema", "St. Julian's", "St. Paul's Bay", "Swieqi", "Ta' Xbiex", "Tarxien", "Valletta", "Victoria", "Xagħra", "Xewkija", "Xgħajra", "Żabbar", "Żebbuġ Gozo", "Żebbuġ Malta", "Żejtun", "Żurrieq"]
    }, {
        name: "Man (Isle of)",
        states: ["Ayre", "Garff", "Glenfaba", "Michael", "Middle", "Rushen"]
    }, {name: "Marshall Islands", states: ["Ralik Chain", "Ratak Chain"]}, {
        name: "Martinique",
        states: []
    }, {
        name: "Mauritania",
        states: ["Adrar", "Assaba", "Brakna", "Dakhlet Nouadhibou", "Gorgol", "Guidimaka", "Hodh Ech Chargui", "Hodh El Gharbi", "Inchiri", "Nouakchott-Nord", "Nouakchott-Ouest", "Nouakchott-Sud", "Tagant", "Tiris Zemmour", "Trarza"]
    }, {
        name: "Mauritius",
        states: ["Agalega Islands", "Black River", "Flacq", "Grand Port", "Moka", "Pamplemousses", "Plaines Wilhems", "Port Louis", "Rivière du Rempart", "Rodrigues Island", "Saint Brandon Islands", "Savanne"]
    }, {name: "Mayotte", states: []}, {
        name: "Mexico",
        states: ["Aguascalientes", "Baja California", "Baja California Sur", "Campeche", "Chiapas", "Chihuahua", "Ciudad de México", "Coahuila de Zaragoza", "Colima", "Durango", "Estado de México", "Guanajuato", "Guerrero", "Hidalgo", "Jalisco", "Michoacán de Ocampo", "Morelos", "Nayarit", "Nuevo León", "Oaxaca", "Puebla", "Querétaro", "Quintana Roo", "San Luis Potosí", "Sinaloa", "Sonora", "Tabasco", "Tamaulipas", "Tlaxcala", "Veracruz de Ignacio de la Llave", "Yucatán", "Zacatecas"]
    }, {name: "Micronesia", states: ["Chuuk State", "Kosrae State", "Pohnpei State", "Yap State"]}, {
        name: "Moldova",
        states: ["Anenii Noi District", "Bălți Municipality", "Basarabeasca District", "Bender Municipality", "Briceni District", "Cahul District", "Călărași District", "Cantemir District", "Căușeni District", "Chișinău Municipality", "Cimișlia District", "Criuleni District", "Dondușeni District", "Drochia District", "Dubăsari District", "Edineț District", "Fălești District", "Florești District", "Gagauzia", "Glodeni District", "Hîncești District", "Ialoveni District", "Nisporeni District", "Ocnița District", "Orhei District", "Rezina District", "Rîșcani District", "Sîngerei District", "Șoldănești District", "Soroca District", "Ștefan Vodă District", "Strășeni District", "Taraclia District", "Telenești District", "Transnistria autonomous territorial unit", "Ungheni District"]
    }, {name: "Monaco", states: ["La Colle", "La Condamine", "Moneghetti"]}, {
        name: "Mongolia",
        states: ["Arkhangai Province", "Bayan-Ölgii Province", "Bayankhongor Province", "Bulgan Province", "Darkhan-Uul Province", "Dornod Province", "Dornogovi Province", "Dundgovi Province", "Govi-Altai Province", "Govisümber Province", "Khentii Province", "Khovd Province", "Khövsgöl Province", "Ömnögovi Province", "Orkhon Province", "Övörkhangai Province", "Selenge Province", "Sükhbaatar Province", "Töv Province", "Uvs Province", "Zavkhan Province"]
    }, {
        name: "Montenegro",
        states: ["Andrijevica Municipality", "Bar Municipality", "Berane Municipality", "Bijelo Polje Municipality", "Budva Municipality", "Danilovgrad Municipality", "Gusinje Municipality", "Kolašin Municipality", "Kotor Municipality", "Mojkovac Municipality", "Nikšić Municipality", "Old Royal Capital Cetinje", "Petnjica Municipality", "Plav Municipality", "Pljevlja Municipality", "Plužine Municipality", "Podgorica Municipality", "Rožaje Municipality", "Šavnik Municipality", "Tivat Municipality", "Ulcinj Municipality", "Žabljak Municipality"]
    }, {name: "Montserrat", states: []}, {
        name: "Morocco",
        states: ["Agadir-Ida-Ou-Tanane", "Al Haouz", "Al Hoceïma", "Aousserd (EH)", "Assa-Zag (EH-partial)", "Azilal", "Béni Mellal", "Béni Mellal-Khénifra", "Benslimane", "Berkane", "Berrechid", "Boujdour (EH)", "Boulemane", "Casablanca", "Casablanca-Settat", "Chefchaouen", "Chichaoua", "Chtouka-Ait Baha", "Dakhla-Oued Ed-Dahab (EH)", "Drâa-Tafilalet", "Driouch", "El Hajeb", "El Jadida", "El Kelâa des Sraghna", "Errachidia", "Es-Semara (EH-partial)", "Essaouira", "Fahs-Anjra", "Fès", "Fès-Meknès", "Figuig", "Fquih Ben Salah", "Guelmim", "Guelmim-Oued Noun (EH-partial)", "Guercif", "Ifrane", "Inezgane-Ait Melloul", "Jerada", "Kénitra", "Khémisset", "Khénifra", "Khouribga", "L'Oriental", "Laâyoune (EH)", "Laâyoune-Sakia El Hamra (EH-partial)", "Larache", "M’diq-Fnideq", "Marrakech", "Marrakesh-Safi", "Médiouna", "Meknès", "Midelt", "Mohammadia", "Moulay Yacoub", "Nador", "Nouaceur", "Ouarzazate", "Oued Ed-Dahab (EH)", "Ouezzane", "Oujda-Angad", "Rabat", "Rabat-Salé-Kénitra", "Rehamna", "Safi", "Salé", "Sefrou", "Settat", "Sidi Bennour", "Sidi Ifni", "Sidi Kacem", "Sidi Slimane", "Skhirate-Témara", "Souss-Massa", "Tan-Tan (EH-partial)", "Tanger-Assilah", "Tanger-Tétouan-Al Hoceïma", "Taounate", "Taourirt", "Tarfaya (EH-partial)", "Taroudannt", "Tata", "Taza", "Tétouan", "Tinghir", "Tiznit", "Youssoufia", "Zagora"]
    }, {
        name: "Mozambique",
        states: ["Cabo Delgado Province", "Gaza Province", "Inhambane Province", "Manica Province", "Maputo", "Maputo Province", "Nampula Province", "Niassa Province", "Sofala Province", "Tete Province", "Zambezia Province"]
    }, {
        name: "Myanmar",
        states: ["Ayeyarwady Region", "Bago", "Chin State", "Kachin State", "Kayah State", "Kayin State", "Magway Region", "Mandalay Region", "Mon State", "Naypyidaw Union Territory", "Rakhine State", "Sagaing Region", "Shan State", "Tanintharyi Region", "Yangon Region"]
    }, {
        name: "Namibia",
        states: ["Erongo Region", "Hardap Region", "Karas Region", "Kavango East Region", "Kavango West Region", "Khomas Region", "Kunene Region", "Ohangwena Region", "Omaheke Region", "Omusati Region", "Oshana Region", "Oshikoto Region", "Otjozondjupa Region", "Zambezi Region"]
    }, {
        name: "Nauru",
        states: ["Aiwo District", "Anabar District", "Anetan District", "Anibare District", "Baiti District", "Boe District", "Buada District", "Denigomodu District", "Ewa District", "Ijuw District", "Meneng District", "Nibok District", "Uaboe District", "Yaren District"]
    }, {
        name: "Nepal",
        states: ["Bagmati", "Gandaki", "Karnali", "Koshi", "Lumbini", "Madhesh", "Sudurpashchim"]
    }, {
        name: "Netherlands",
        states: ["Bonaire", "Drenthe", "Flevoland", "Friesland", "Gelderland", "Groningen", "Limburg", "North Brabant", "North Holland", "Overijssel", "Saba", "Sint Eustatius", "South Holland", "Utrecht", "Zeeland"]
    }, {
        name: "New Caledonia",
        states: ["Loyalty Islands Province", "North Province", "South Province"]
    }, {
        name: "New Zealand",
        states: ["Auckland Region", "Bay of Plenty Region", "Canterbury Region", "Chatham Islands", "Gisborne District", "Hawke's Bay Region", "Manawatu-Wanganui Region", "Marlborough Region", "Nelson Region", "Northland Region", "Otago Region", "Southland Region", "Taranaki Region", "Tasman District", "Waikato Region", "Wellington Region", "West Coast Region"]
    }, {
        name: "Nicaragua",
        states: ["Boaco", "Carazo", "Chinandega", "Chontales", "Estelí", "Granada", "Jinotega", "León", "Madriz", "Managua", "Masaya", "Matagalpa", "North Caribbean Coast", "Nueva Segovia", "Río San Juan", "Rivas", "South Caribbean Coast"]
    }, {
        name: "Niger",
        states: ["Agadez Region", "Diffa Region", "Dosso Region", "Maradi Region", "Tahoua Region", "Tillabéri Region", "Zinder Region"]
    }, {
        name: "Nigeria",
        states: ["Abia", "Abuja Federal Capital Territory", "Adamawa", "Akwa Ibom", "Anambra", "Bauchi", "Bayelsa", "Benue", "Borno", "Cross River", "Delta", "Ebonyi", "Edo", "Ekiti", "Enugu", "Gombe", "Imo", "Jigawa", "Kaduna", "Kano", "Katsina", "Kebbi", "Kogi", "Kwara", "Lagos", "Nasarawa", "Niger", "Ogun", "Ondo", "Osun", "Oyo", "Plateau", "Rivers", "Sokoto", "Taraba", "Yobe", "Zamfara"]
    }, {name: "Niue", states: []}, {name: "Norfolk Island", states: []}, {
        name: "North Korea",
        states: ["Chagang Province", "Kangwon Province", "North Hamgyong Province", "North Hwanghae Province", "North Pyongan Province", "Pyongyang", "Rason", "Ryanggang Province", "South Hamgyong Province", "South Hwanghae Province", "South Pyongan Province"]
    }, {
        name: "North Macedonia",
        states: ["Aerodrom Municipality", "Aračinovo Municipality", "Berovo Municipality", "Bitola Municipality", "Bogdanci Municipality", "Bogovinje Municipality", "Bosilovo Municipality", "Brvenica Municipality", "Butel Municipality", "Čair Municipality", "Čaška Municipality", "Centar Municipality", "Centar Župa Municipality", "Češinovo-Obleševo Municipality", "Čučer-Sandevo Municipality", "Debarca Municipality", "Delčevo Municipality", "Demir Hisar Municipality", "Demir Kapija Municipality", "Dojran Municipality", "Dolneni Municipality", "Drugovo Municipality", "Gazi Baba Municipality", "Gevgelija Municipality", "Gjorče Petrov Municipality", "Gostivar Municipality", "Gradsko Municipality", "Greater Skopje", "Ilinden Municipality", "Jegunovce Municipality", "Karbinci", "Karpoš Municipality", "Kavadarci Municipality", "Kičevo Municipality", "Kisela Voda Municipality", "Kočani Municipality", "Konče Municipality", "Kratovo Municipality", "Kriva Palanka Municipality", "Krivogaštani Municipality", "Kruševo Municipality", "Kumanovo Municipality", "Lipkovo Municipality", "Lozovo Municipality", "Makedonska Kamenica Municipality", "Makedonski Brod Municipality", "Mavrovo and Rostuša Municipality", "Mogila Municipality", "Negotino Municipality", "Novaci Municipality", "Novo Selo Municipality", "Ohrid Municipality", "Oslomej Municipality", "Pehčevo Municipality", "Petrovec Municipality", "Plasnica Municipality", "Prilep Municipality", "Probištip Municipality", "Radoviš Municipality", "Rankovce Municipality", "Resen Municipality", "Rosoman Municipality", "Saraj Municipality", "Sopište Municipality", "Staro Nagoričane Municipality", "Štip Municipality", "Struga Municipality", "Strumica Municipality", "Studeničani Municipality", "Šuto Orizari Municipality", "Sveti Nikole Municipality", "Tearce Municipality", "Tetovo Municipality", "Valandovo Municipality", "Vasilevo Municipality", "Veles Municipality", "Vevčani Municipality", "Vinica Municipality", "Vraneštica Municipality", "Vrapčište Municipality", "Zajas Municipality", "Zelenikovo Municipality", "Želino Municipality", "Zrnovci Municipality"]
    }, {name: "Northern Mariana Islands", states: []}, {
        name: "Norway",
        states: ["Agder", "Innlandet", "Jan Mayen", "Møre og Romsdal", "Nordland", "Oslo", "Rogaland", "Svalbard", "Troms og Finnmark", "Trøndelag", "Vestfold og Telemark", "Vestland", "Viken"]
    }, {
        name: "Oman",
        states: ["Ad Dakhiliyah", "Ad Dhahirah", "Al Batinah North", "Al Batinah Region", "Al Batinah South", "Al Buraimi", "Al Wusta", "Ash Sharqiyah North", "Ash Sharqiyah Region", "Ash Sharqiyah South", "Dhofar", "Musandam", "Muscat"]
    }, {
        name: "Pakistan",
        states: ["Azad Kashmir", "Balochistan", "Federally Administered Tribal Areas", "Gilgit-Baltistan", "Islamabad Capital Territory", "Khyber Pakhtunkhwa", "Punjab", "Sindh"]
    }, {
        name: "Palau",
        states: ["Aimeliik", "Airai", "Angaur", "Hatohobei", "Kayangel", "Koror", "Melekeok", "Ngaraard", "Ngarchelong", "Ngardmau", "Ngatpang", "Ngchesar", "Ngeremlengui", "Ngiwal", "Peleliu", "Sonsorol"]
    }, {
        name: "Palestinian Territory Occupied",
        states: ["Bethlehem", "Deir El Balah", "Gaza", "Hebron", "Jenin", "Jericho ", "Jerusalem (Quds)", "Khan Yunis", "Nablus", "North Gaza", "Qalqilya", "Rafah", "Ramallah", "Salfit", "Tubas", "Tulkarm"]
    }, {
        name: "Panama",
        states: ["Bocas del Toro Province", "Chiriquí Province", "Coclé Province", "Colón Province", "Darién Province", "Emberá-Wounaan Comarca", "Guna Yala", "Herrera Province", "Los Santos Province", "Ngöbe-Buglé Comarca", "Panamá Oeste Province", "Panamá Province", "Veraguas Province"]
    }, {
        name: "Papua New Guinea",
        states: ["Bougainville", "Central Province", "Chimbu Province", "East New Britain", "East Sepik", "Eastern Highlands Province", "Enga Province", "Gulf", "Hela", "Jiwaka Province", "Madang Province", "Manus Province", "Milne Bay Province", "Morobe Province", "New Ireland Province", "Oro Province", "Port Moresby", "Sandaun Province", "Southern Highlands Province", "West New Britain Province", "Western Highlands Province", "Western Province"]
    }, {
        name: "Paraguay",
        states: ["Alto Paraguay Department", "Alto Paraná Department", "Amambay Department", "Asuncion", "Boquerón Department", "Caaguazú", "Caazapá", "Canindeyú", "Central Department", "Concepción Department", "Cordillera Department", "Guairá Department", "Itapúa", "Misiones Department", "Ñeembucú Department", "Paraguarí Department", "Presidente Hayes Department", "San Pedro Department"]
    }, {
        name: "Peru",
        states: ["Amazonas", "Áncash", "Apurímac", "Arequipa", "Ayacucho", "Cajamarca", "Callao", "Cusco", "Huancavelica", "Huanuco", "Ica", "Junín", "La Libertad", "Lambayeque", "Lima", "Loreto", "Madre de Dios", "Moquegua", "Pasco", "Piura", "Puno", "San Martín", "Tacna", "Tumbes", "Ucayali"]
    }, {
        name: "Philippines",
        states: ["Abra", "Agusan del Norte", "Agusan del Sur", "Aklan", "Albay", "Antique", "Apayao", "Aurora", "Autonomous Region in Muslim Mindanao", "Basilan", "Bataan", "Batanes", "Batangas", "Benguet", "Bicol", "Biliran", "Bohol", "Bukidnon", "Bulacan", "Cagayan", "Cagayan Valley", "Calabarzon", "Camarines Norte", "Camarines Sur", "Camiguin", "Capiz", "Caraga", "Catanduanes", "Cavite", "Cebu", "Central Luzon", "Central Visayas", "Compostela Valley", "Cordillera Administrative", "Cotabato", "Davao", "Davao del Norte", "Davao del Sur", "Davao Occidental", "Davao Oriental", "Dinagat Islands", "Eastern Samar", "Eastern Visayas", "Guimaras", "Ifugao", "Ilocos", "Ilocos Norte", "Ilocos Sur", "Iloilo", "Isabela", "Kalinga", "La Union", "Laguna", "Lanao del Norte", "Lanao del Sur", "Leyte", "Maguindanao", "Marinduque", "Masbate", "Metro Manila", "Mimaropa", "Misamis Occidental", "Misamis Oriental", "Mountain Province", "Negros Occidental", "Negros Oriental", "Northern Mindanao", "Northern Samar", "Nueva Ecija", "Nueva Vizcaya", "Occidental Mindoro", "Oriental Mindoro", "Palawan", "Pampanga", "Pangasinan", "Quezon", "Quirino", "Rizal", "Romblon", "Sarangani", "Siquijor", "Soccsksargen", "Sorsogon", "South Cotabato", "Southern Leyte", "Sultan Kudarat", "Sulu", "Surigao del Norte", "Surigao del Sur", "Tarlac", "Tawi-Tawi", "Western Samar", "Western Visayas", "Zambales", "Zamboanga del Norte", "Zamboanga del Sur", "Zamboanga Peninsula", "Zamboanga Sibugay"]
    }, {name: "Pitcairn Island", states: []}, {
        name: "Poland",
        states: ["Greater Poland", "Holy Cross", "Kuyavia-Pomerania", "Lesser Poland", "Lower Silesia", "Lublin", "Lubusz", "Łódź", "Mazovia", "Podlaskie", "Pomerania", "Silesia", "Subcarpathia", "Upper Silesia", "Warmia-Masuria", "West Pomerania"]
    }, {
        name: "Portugal",
        states: ["Açores", "Aveiro", "Beja", "Braga", "Bragança", "Castelo Branco", "Coimbra", "Évora", "Faro", "Guarda", "Leiria", "Lisbon", "Madeira", "Portalegre", "Porto", "Santarém", "Setúbal", "Viana do Castelo", "Vila Real", "Viseu"]
    }, {
        name: "Puerto Rico",
        states: ["Adjuntas", "Aguada", "Aguadilla", "Aguas Buenas", "Aibonito", "Añasco", "Arecibo", "Arecibo", "Arroyo", "Barceloneta", "Barranquitas", "Bayamon", "Bayamón", "Cabo Rojo", "Caguas", "Caguas", "Camuy", "Canóvanas", "Carolina", "Carolina", "Cataño", "Cayey", "Ceiba", "Ciales", "Cidra", "Coamo", "Comerío", "Corozal", "Culebra", "Dorado", "Fajardo", "Florida", "Guánica", "Guayama", "Guayanilla", "Guaynabo", "Guaynabo", "Gurabo", "Hatillo", "Hormigueros", "Humacao", "Isabela", "Jayuya", "Juana Díaz", "Juncos", "Lajas", "Lares", "Las Marías", "Las Piedras", "Loíza", "Luquillo", "Manatí", "Maricao", "Maunabo", "Mayagüez", "Mayagüez", "Moca", "Morovis", "Naguabo", "Naranjito", "Orocovis", "Patillas", "Peñuelas", "Ponce", "Ponce", "Quebradillas", "Rincón", "Río Grande", "Sabana Grande", "Salinas", "San Germán", "San Juan", "San Juan", "San Lorenzo", "San Sebastián", "Santa Isabel", "Toa Alta", "Toa Baja", "Toa Baja", "Trujillo Alto", "Trujillo Alto", "Utuado", "Vega Alta", "Vega Baja", "Vieques", "Villalba", "Yabucoa", "Yauco"]
    }, {
        name: "Qatar",
        states: ["Al Daayen", "Al Khor", "Al Rayyan Municipality", "Al Wakrah", "Al-Shahaniya", "Doha", "Madinat ash Shamal", "Umm Salal Municipality"]
    }, {name: "Reunion", states: []}, {
        name: "Romania",
        states: ["Alba", "Arad County", "Arges", "Bacău County", "Bihor County", "Bistrița-Năsăud County", "Botoșani County", "Braila", "Brașov County", "Bucharest", "Buzău County", "Călărași County", "Caraș-Severin County", "Cluj County", "Constanța County", "Covasna County", "Dâmbovița County", "Dolj County", "Galați County", "Giurgiu County", "Gorj County", "Harghita County", "Hunedoara County", "Ialomița County", "Iași County", "Ilfov County", "Maramureș County", "Mehedinți County", "Mureș County", "Neamț County", "Olt County", "Prahova County", "Sălaj County", "Satu Mare County", "Sibiu County", "Suceava County", "Teleorman County", "Timiș County", "Tulcea County", "Vâlcea County", "Vaslui County", "Vrancea County"]
    }, {
        name: "Russia",
        states: ["Altai Krai", "Altai Republic", "Amur Oblast", "Arkhangelsk", "Astrakhan Oblast", "Belgorod Oblast", "Bryansk Oblast", "Chechen Republic", "Chelyabinsk Oblast", "Chukotka Autonomous Okrug", "Chuvash Republic", "Irkutsk", "Ivanovo Oblast", "Jewish Autonomous Oblast", "Kabardino-Balkar Republic", "Kaliningrad", "Kaluga Oblast", "Kamchatka Krai", "Karachay-Cherkess Republic", "Kemerovo Oblast", "Khabarovsk Krai", "Khanty-Mansi Autonomous Okrug", "Kirov Oblast", "Komi Republic", "Kostroma Oblast", "Krasnodar Krai", "Krasnoyarsk Krai", "Kurgan Oblast", "Kursk Oblast", "Leningrad Oblast", "Lipetsk Oblast", "Magadan Oblast", "Mari El Republic", "Moscow", "Moscow Oblast", "Murmansk Oblast", "Nenets Autonomous Okrug", "Nizhny Novgorod Oblast", "Novgorod Oblast", "Novosibirsk", "Omsk Oblast", "Orenburg Oblast", "Oryol Oblast", "Penza Oblast", "Perm Krai", "Primorsky Krai", "Pskov Oblast", "Republic of Adygea", "Republic of Bashkortostan", "Republic of Buryatia", "Republic of Dagestan", "Republic of Ingushetia", "Republic of Kalmykia", "Republic of Karelia", "Republic of Khakassia", "Republic of Mordovia", "Republic of North Ossetia-Alania", "Republic of Tatarstan", "Rostov Oblast", "Ryazan Oblast", "Saint Petersburg", "Sakha Republic", "Sakhalin", "Samara Oblast", "Saratov Oblast", "Smolensk Oblast", "Stavropol Krai", "Sverdlovsk", "Tambov Oblast", "Tomsk Oblast", "Tula Oblast", "Tuva Republic", "Tver Oblast", "Tyumen Oblast", "Udmurt Republic", "Ulyanovsk Oblast", "Vladimir Oblast", "Volgograd Oblast", "Vologda Oblast", "Voronezh Oblast", "Yamalo-Nenets Autonomous Okrug", "Yaroslavl Oblast", "Zabaykalsky Krai"]
    }, {
        name: "Rwanda",
        states: ["Eastern Province", "Kigali district", "Northern Province", "Southern Province", "Western Province"]
    }, {name: "Saint Helena", states: []}, {
        name: "Saint Kitts and Nevis",
        states: ["Christ Church Nichola Town Parish", "Nevis", "Saint Anne Sandy Point Parish", "Saint George Gingerland Parish", "Saint James Windward Parish", "Saint John Capisterre Parish", "Saint John Figtree Parish", "Saint Kitts", "Saint Mary Cayon Parish", "Saint Paul Capisterre Parish", "Saint Paul Charlestown Parish", "Saint Peter Basseterre Parish", "Saint Thomas Lowland Parish", "Saint Thomas Middle Island Parish", "Trinity Palmetto Point Parish"]
    }, {
        name: "Saint Lucia",
        states: ["Anse la Raye Quarter", "Canaries", "Castries Quarter", "Choiseul Quarter", "Dauphin Quarter", "Dennery Quarter", "Gros Islet Quarter", "Laborie Quarter", "Micoud Quarter", "Praslin Quarter", "Soufrière Quarter", "Vieux Fort Quarter"]
    }, {name: "Saint Pierre and Miquelon", states: []}, {
        name: "Saint Vincent and the Grenadines",
        states: ["Charlotte Parish", "Grenadines Parish", "Saint Andrew Parish", "Saint David Parish", "Saint George Parish", "Saint Patrick Parish"]
    }, {name: "Saint-Barthelemy", states: []}, {name: "Saint-Martin (French part)", states: []}, {
        name: "Samoa",
        states: ["A'ana", "Aiga-i-le-Tai", "Atua", "Fa'asaleleaga", "Gaga'emauga", "Gaga'ifomauga", "Palauli", "Satupa'itea", "Tuamasaga", "Va'a-o-Fonoti", "Vaisigano"]
    }, {
        name: "San Marino",
        states: ["Acquaviva", "Borgo Maggiore", "Chiesanuova", "Domagnano", "Faetano", "Fiorentino", "Montegiardino", "San Marino", "Serravalle"]
    }, {name: "Sao Tome and Principe", states: ["Príncipe Province", "São Tomé Province"]}, {
        name: "Saudi Arabia",
        states: ["'Asir", "Al Bahah", "Al Jawf", "Al Madinah", "Al-Qassim", "Eastern Province", "Ha'il", "Jizan", "Makkah", "Najran", "Northern Borders", "Riyadh", "Tabuk"]
    }, {
        name: "Senegal",
        states: ["Dakar", "Diourbel Region", "Fatick", "Kaffrine", "Kaolack", "Kédougou", "Kolda", "Louga", "Matam", "Saint-Louis", "Sédhiou", "Tambacounda Region", "Thiès Region", "Ziguinchor"]
    }, {
        name: "Serbia",
        states: ["Belgrade", "Bor District", "Braničevo District", "Central Banat District", "Jablanica District", "Kolubara District", "Mačva District", "Moravica District", "Nišava District", "North Bačka District", "North Banat District", "Pčinja District", "Pirot District", "Podunavlje District", "Pomoravlje District", "Rasina District", "Raška District", "South Bačka District", "South Banat District", "Srem District", "Šumadija District", "Toplica District", "Vojvodina", "West Bačka District", "Zaječar District", "Zlatibor District"]
    }, {
        name: "Seychelles",
        states: ["Anse Boileau", "Anse Royale", "Anse-aux-Pins", "Au Cap", "Baie Lazare", "Baie Sainte Anne", "Beau Vallon", "Bel Air", "Bel Ombre", "Cascade", "Glacis", "Grand'Anse Mahé", "Grand'Anse Praslin", "La Digue", "La Rivière Anglaise", "Les Mamelles", "Mont Buxton", "Mont Fleuri", "Plaisance", "Pointe La Rue", "Port Glaud", "Roche Caiman", "Saint Louis", "Takamaka"]
    }, {
        name: "Sierra Leone",
        states: ["Eastern Province", "Northern Province", "Southern Province", "Western Area"]
    }, {
        name: "Singapore",
        states: ["Central Singapore", "North East", "North West", "South East", "South West"]
    }, {name: "Sint Maarten (Dutch part)", states: []}, {
        name: "Slovakia",
        states: ["Banská Bystrica Region", "Bratislava Region", "Košice Region", "Nitra Region", "Prešov Region", "Trenčín Region", "Trnava Region", "Žilina Region"]
    }, {
        name: "Slovenia",
        states: ["Ajdovščina Municipality", "Ankaran Municipality", "Beltinci Municipality", "Benedikt Municipality", "Bistrica ob Sotli Municipality", "Bled Municipality", "Bloke Municipality", "Bohinj Municipality", "Borovnica Municipality", "Bovec Municipality", "Braslovče Municipality", "Brda Municipality", "Brežice Municipality", "Brezovica Municipality", "Cankova Municipality", "Cerklje na Gorenjskem Municipality", "Cerknica Municipality", "Cerkno Municipality", "Cerkvenjak Municipality", "City Municipality of Celje", "City Municipality of Novo Mesto", "Črenšovci Municipality", "Črna na Koroškem Municipality", "Črnomelj Municipality", "Destrnik Municipality", "Divača Municipality", "Dobje Municipality", "Dobrepolje Municipality", "Dobrna Municipality", "Dobrova–Polhov Gradec Municipality", "Dobrovnik Municipality", "Dol pri Ljubljani Municipality", "Dolenjske Toplice Municipality", "Domžale Municipality", "Dornava Municipality", "Dravograd Municipality", "Duplek Municipality", "Gorenja Vas–Poljane Municipality", "Gorišnica Municipality", "Gorje Municipality", "Gornja Radgona Municipality", "Gornji Grad Municipality", "Gornji Petrovci Municipality", "Grad Municipality", "Grosuplje Municipality", "Hajdina Municipality", "Hoče–Slivnica Municipality", "Hodoš Municipality", "Horjul Municipality", "Hrastnik Municipality", "Hrpelje–Kozina Municipality", "Idrija Municipality", "Ig Municipality", "Ivančna Gorica Municipality", "Izola Municipality", "Jesenice Municipality", "Jezersko Municipality", "Juršinci Municipality", "Kamnik Municipality", "Kanal ob Soči Municipality", "Kidričevo Municipality", "Kobarid Municipality", "Kobilje Municipality", "Kočevje Municipality", "Komen Municipality", "Komenda Municipality", "Koper City Municipality", "Kostanjevica na Krki Municipality", "Kostel Municipality", "Kozje Municipality", "Kranj City Municipality", "Kranjska Gora Municipality", "Križevci Municipality", "Kungota", "Kuzma Municipality", "Laško Municipality", "Lenart Municipality", "Lendava Municipality", "Litija Municipality", "Ljubljana City Municipality", "Ljubno Municipality", "Ljutomer Municipality", "Log–Dragomer Municipality", "Logatec Municipality", "Loška Dolina Municipality", "Loški Potok Municipality", "Lovrenc na Pohorju Municipality", "Luče Municipality", "Lukovica Municipality", "Majšperk Municipality", "Makole Municipality", "Maribor City Municipality", "Markovci Municipality", "Medvode Municipality", "Mengeš Municipality", "Metlika Municipality", "Mežica Municipality", "Miklavž na Dravskem Polju Municipality", "Miren–Kostanjevica Municipality", "Mirna Municipality", "Mirna Peč Municipality", "Mislinja Municipality", "Mokronog–Trebelno Municipality", "Moravče Municipality", "Moravske Toplice Municipality", "Mozirje Municipality", "Municipality of Apače", "Municipality of Cirkulane", "Municipality of Ilirska Bistrica", "Municipality of Krško", "Municipality of Škofljica", "Murska Sobota City Municipality", "Muta Municipality", "Naklo Municipality", "Nazarje Municipality", "Nova Gorica City Municipality", "Odranci Municipality", "Oplotnica", "Ormož Municipality", "Osilnica Municipality", "Pesnica Municipality", "Piran Municipality", "Pivka Municipality", "Podčetrtek Municipality", "Podlehnik Municipality", "Podvelka Municipality", "Poljčane Municipality", "Polzela Municipality", "Postojna Municipality", "Prebold Municipality", "Preddvor Municipality", "Prevalje Municipality", "Ptuj City Municipality", "Puconci Municipality", "Rače–Fram Municipality", "Radeče Municipality", "Radenci Municipality", "Radlje ob Dravi Municipality", "Radovljica Municipality", "Ravne na Koroškem Municipality", "Razkrižje Municipality", "Rečica ob Savinji Municipality", "Renče–Vogrsko Municipality", "Ribnica Municipality", "Ribnica na Pohorju Municipality", "Rogaška Slatina Municipality", "Rogašovci Municipality", "Rogatec Municipality", "Ruše Municipality", "Šalovci Municipality", "Selnica ob Dravi Municipality", "Semič Municipality", "Šempeter–Vrtojba Municipality", "Šenčur Municipality", "Šentilj Municipality", "Šentjernej Municipality", "Šentjur Municipality", "Šentrupert Municipality", "Sevnica Municipality", "Sežana Municipality", "Škocjan Municipality", "Škofja Loka Municipality", "Slovenj Gradec City Municipality", "Slovenska Bistrica Municipality", "Slovenske Konjice Municipality", "Šmarje pri Jelšah Municipality", "Šmarješke Toplice Municipality", "Šmartno ob Paki Municipality", "Šmartno pri Litiji Municipality", "Sodražica Municipality", "Solčava Municipality", "Šoštanj Municipality", "Središče ob Dravi", "Starše Municipality", "Štore Municipality", "Straža Municipality", "Sveta Ana Municipality", "Sveta Trojica v Slovenskih Goricah Municipality", "Sveti Andraž v Slovenskih Goricah Municipality", "Sveti Jurij ob Ščavnici Municipality", "Sveti Jurij v Slovenskih Goricah Municipality", "Sveti Tomaž Municipality", "Tabor Municipality", "Tišina Municipality", "Tolmin Municipality", "Trbovlje Municipality", "Trebnje Municipality", "Trnovska Vas Municipality", "Tržič Municipality", "Trzin Municipality", "Turnišče Municipality", "Velika Polana Municipality", "Velike Lašče Municipality", "Veržej Municipality", "Videm Municipality", "Vipava Municipality", "Vitanje Municipality", "Vodice Municipality", "Vojnik Municipality", "Vransko Municipality", "Vrhnika Municipality", "Vuzenica Municipality", "Zagorje ob Savi Municipality", "Žalec Municipality", "Zavrč Municipality", "Železniki Municipality", "Žetale Municipality", "Žiri Municipality", "Žirovnica Municipality", "Zreče Municipality", "Žužemberk Municipality"]
    }, {
        name: "Solomon Islands",
        states: ["Central Province", "Choiseul Province", "Guadalcanal Province", "Honiara", "Isabel Province", "Makira-Ulawa Province", "Malaita Province", "Rennell and Bellona Province", "Temotu Province", "Western Province"]
    }, {
        name: "Somalia",
        states: ["Awdal Region", "Bakool", "Banaadir", "Bari", "Bay", "Galguduud", "Gedo", "Hiran", "Lower Juba", "Lower Shebelle", "Middle Juba", "Middle Shebelle", "Mudug", "Nugal", "Sanaag Region", "Togdheer Region"]
    }, {
        name: "South Africa",
        states: ["Eastern Cape", "Free State", "Gauteng", "KwaZulu-Natal", "Limpopo", "Mpumalanga", "North West", "Northern Cape", "Western Cape"]
    }, {name: "South Georgia", states: []}, {
        name: "South Korea",
        states: ["Busan", "Daegu", "Daejeon", "Gangwon Province", "Gwangju", "Gyeonggi Province", "Incheon", "Jeju", "North Chungcheong Province", "North Gyeongsang Province", "North Jeolla Province", "Sejong City", "Seoul", "South Chungcheong Province", "South Gyeongsang Province", "South Jeolla Province", "Ulsan"]
    }, {
        name: "South Sudan",
        states: ["Central Equatoria", "Eastern Equatoria", "Jonglei State", "Lakes", "Northern Bahr el Ghazal", "Unity", "Upper Nile", "Warrap", "Western Bahr el Ghazal", "Western Equatoria"]
    }, {
        name: "Spain",
        states: ["A Coruña", "Albacete", "Alicante", "Almeria", "Araba", "Asturias", "Ávila", "Badajoz", "Barcelona", "Bizkaia", "Burgos", "Caceres", "Cádiz", "Canarias", "Cantabria", "Castellón", "Ceuta", "Ciudad Real", "Córdoba", "Cuenca", "Gipuzkoa", "Girona", "Granada", "Guadalajara", "Huelva", "Huesca", "Islas Baleares", "Jaén", "La Rioja", "Las Palmas", "León", "Lleida", "Lugo", "Madrid", "Málaga", "Melilla", "Murcia", "Navarra", "Ourense", "Palencia", "Pontevedra", "Salamanca", "Santa Cruz de Tenerife", "Segovia", "Sevilla", "Soria", "Tarragona", "Teruel", "Toledo", "Valencia", "Valladolid", "Zamora", "Zaragoza"]
    }, {
        name: "Sri Lanka",
        states: ["Ampara District", "Anuradhapura District", "Badulla District", "Batticaloa District", "Central Province", "Colombo District", "Eastern Province", "Galle District", "Gampaha District", "Hambantota District", "Jaffna District", "Kalutara District", "Kandy District", "Kegalle District", "Kilinochchi District", "Mannar District", "Matale District", "Matara District", "Monaragala District", "Mullaitivu District", "North Central Province", "North Western Province", "Northern Province", "Nuwara Eliya District", "Polonnaruwa District", "Puttalam District", "Ratnapura district", "Sabaragamuwa Province", "Southern Province", "Trincomalee District", "Uva Province", "Vavuniya District", "Western Province"]
    }, {
        name: "Sudan",
        states: ["Al Jazirah", "Al Qadarif", "Blue Nile", "Central Darfur", "East Darfur", "Kassala", "Khartoum", "North Darfur", "North Kordofan", "Northern", "Red Sea", "River Nile", "Sennar", "South Darfur", "South Kordofan", "West Darfur", "West Kordofan", "White Nile"]
    }, {
        name: "Suriname",
        states: ["Brokopondo District", "Commewijne District", "Coronie District", "Marowijne District", "Nickerie District", "Para District", "Paramaribo District", "Saramacca District", "Sipaliwini District", "Wanica District"]
    }, {name: "Svalbard and Jan Mayen Islands", states: []}, {
        name: "Sweden",
        states: ["Blekinge County", "Dalarna County", "Gävleborg County", "Gotland County", "Halland County", "Jämtland County", "Jönköping County", "Kalmar County", "Kronoberg County", "Norrbotten County", "Örebro County", "Östergötland County", "Skåne County", "Södermanland County", "Stockholm County", "Uppsala County", "Värmland County", "Västerbotten County", "Västernorrland County", "Västmanland County", "Västra Götaland County"]
    }, {
        name: "Switzerland",
        states: ["Aargau", "Appenzell Ausserrhoden", "Appenzell Innerrhoden", "Basel-Land", "Basel-Stadt", "Bern", "Fribourg", "Geneva", "Glarus", "Graubünden", "Jura", "Lucerne", "Neuchâtel", "Nidwalden", "Obwalden", "Schaffhausen", "Schwyz", "Solothurn", "St. Gallen", "Thurgau", "Ticino", "Uri", "Valais", "Vaud", "Zug", "Zürich"]
    }, {
        name: "Syria",
        states: ["Al-Hasakah", "Al-Raqqah", "Aleppo", "As-Suwayda", "Damascus", "Daraa", "Deir ez-Zor", "Hama", "Homs", "Idlib", "Latakia", "Quneitra", "Rif Dimashq", "Tartus"]
    }, {
        name: "Taiwan",
        states: ["Changhua", "Chiayi", "Chiayi", "Hsinchu", "Hsinchu", "Hualien", "Kaohsiung", "Keelung", "Kinmen", "Lienchiang", "Miaoli", "Nantou", "New Taipei", "Penghu", "Pingtung", "Taichung", "Tainan", "Taipei", "Taitung", "Taoyuan", "Yilan", "Yunlin"]
    }, {
        name: "Tajikistan",
        states: ["districts of Republican Subordination", "Gorno-Badakhshan Autonomous Province", "Khatlon Province", "Sughd Province"]
    }, {
        name: "Tanzania",
        states: ["Arusha", "Dar es Salaam", "Dodoma", "Geita", "Iringa", "Kagera", "Katavi", "Kigoma", "Kilimanjaro", "Lindi", "Manyara", "Mara", "Mbeya", "Morogoro", "Mtwara", "Mwanza", "Njombe", "Pemba North", "Pemba South", "Pwani", "Rukwa", "Ruvuma", "Shinyanga", "Simiyu", "Singida", "Songwe", "Tabora", "Tanga", "Zanzibar North", "Zanzibar South", "Zanzibar West"]
    }, {
        name: "Thailand",
        states: ["Amnat Charoen", "Ang Thong", "Bangkok", "Bueng Kan", "Buri Ram", "Chachoengsao", "Chai Nat", "Chaiyaphum", "Chanthaburi", "Chiang Mai", "Chiang Rai", "Chon Buri", "Chumphon", "Kalasin", "Kamphaeng Phet", "Kanchanaburi", "Khon Kaen", "Krabi", "Lampang", "Lamphun", "Loei", "Lop Buri", "Mae Hong Son", "Maha Sarakham", "Mukdahan", "Nakhon Nayok", "Nakhon Pathom", "Nakhon Phanom", "Nakhon Ratchasima", "Nakhon Sawan", "Nakhon Si Thammarat", "Nan", "Narathiwat", "Nong Bua Lam Phu", "Nong Khai", "Nonthaburi", "Pathum Thani", "Pattani", "Pattaya", "Phangnga", "Phatthalung", "Phayao", "Phetchabun", "Phetchaburi", "Phichit", "Phitsanulok", "Phra Nakhon Si Ayutthaya", "Phrae", "Phuket", "Prachin Buri", "Prachuap Khiri Khan", "Ranong", "Ratchaburi", "Rayong", "Roi Et", "Sa Kaeo", "Sakon Nakhon", "Samut Prakan", "Samut Sakhon", "Samut Songkhram", "Saraburi", "Satun", "Si Sa Ket", "Sing Buri", "Songkhla", "Sukhothai", "Suphan Buri", "Surat Thani", "Surin", "Tak", "Trang", "Trat", "Ubon Ratchathani", "Udon Thani", "Uthai Thani", "Uttaradit", "Yala", "Yasothon"]
    }, {
        name: "The Bahamas",
        states: ["Acklins", "Acklins and Crooked Islands", "Berry Islands", "Bimini", "Black Point", "Cat Island", "Central Abaco", "Central Andros", "Central Eleuthera", "Crooked Island", "East Grand Bahama", "Exuma", "Freeport", "Fresh Creek", "Governor's Harbour", "Grand Cay", "Green Turtle Cay", "Harbour Island", "High Rock", "Hope Town", "Inagua", "Kemps Bay", "Long Island", "Mangrove Cay", "Marsh Harbour", "Mayaguana District", "New Providence", "Nichollstown and Berry Islands", "North Abaco", "North Andros", "North Eleuthera", "Ragged Island", "Rock Sound", "Rum Cay District", "San Salvador and Rum Cay", "San Salvador Island", "Sandy Point", "South Abaco", "South Andros", "South Eleuthera", "Spanish Wells", "West Grand Bahama"]
    }, {
        name: "The Gambia ",
        states: ["Banjul", "Central River Division", "Lower River Division", "North Bank Division", "Upper River Division", "West Coast Division"]
    }, {
        name: "Timor-Leste",
        states: ["Aileu municipality", "Ainaro Municipality", "Baucau Municipality", "Bobonaro Municipality", "Cova Lima Municipality", "Dili municipality", "Ermera District", "Lautém Municipality", "Liquiçá Municipality", "Manatuto District", "Manufahi Municipality", "Viqueque Municipality"]
    }, {
        name: "Togo",
        states: ["Centrale Region", "Kara Region", "Maritime", "Plateaux Region", "Savanes Region"]
    }, {name: "Tokelau", states: []}, {
        name: "Tonga",
        states: ["Haʻapai", "ʻEua", "Niuas", "Tongatapu", "Vavaʻu"]
    }, {
        name: "Trinidad and Tobago",
        states: ["Arima", "Chaguanas", "Couva-Tabaquite-Talparo Regional Corporation", "Diego Martin Regional Corporation", "Eastern Tobago", "Penal-Debe Regional Corporation", "Point Fortin", "Port of Spain", "Princes Town Regional Corporation", "Rio Claro-Mayaro Regional Corporation", "San Fernando", "San Juan-Laventille Regional Corporation", "Sangre Grande Regional Corporation", "Siparia Regional Corporation", "Tunapuna-Piarco Regional Corporation", "Western Tobago"]
    }, {
        name: "Tunisia",
        states: ["Ariana", "Béja", "Ben Arous", "Bizerte", "Gabès", "Gafsa", "Jendouba", "Kairouan", "Kasserine", "Kebili", "Kef", "Mahdia", "Manouba", "Medenine", "Monastir", "Nabeul", "Sfax", "Sidi Bouzid", "Siliana", "Sousse", "Tataouine", "Tozeur", "Tunis", "Zaghouan"]
    }, {
        name: "Turkey",
        states: ["Adana", "Adıyaman", "Afyonkarahisar", "Ağrı", "Aksaray", "Amasya", "Ankara", "Antalya", "Ardahan", "Artvin", "Aydın", "Balıkesir", "Bartın", "Batman", "Bayburt", "Bilecik", "Bingöl", "Bitlis", "Bolu", "Burdur", "Bursa", "Çanakkale", "Çankırı", "Çorum", "Denizli", "Diyarbakır", "Düzce", "Edirne", "Elazığ", "Erzincan", "Erzurum", "Eskişehir", "Gaziantep", "Giresun", "Gümüşhane", "Hakkâri", "Hatay", "Iğdır", "Isparta", "İstanbul", "İzmir", "Kahramanmaraş", "Karabük", "Karaman", "Kars", "Kastamonu", "Kayseri", "Kilis", "Kırıkkale", "Kırklareli", "Kırşehir", "Kocaeli", "Konya", "Kütahya", "Malatya", "Manisa", "Mardin", "Mersin", "Muğla", "Muş", "Nevşehir", "Niğde", "Ordu", "Osmaniye", "Rize", "Sakarya", "Samsun", "Şanlıurfa", "Siirt", "Sinop", "Sivas", "Şırnak", "Tekirdağ", "Tokat", "Trabzon", "Tunceli", "Uşak", "Van", "Yalova", "Yozgat", "Zonguldak"]
    }, {
        name: "Turkmenistan",
        states: ["Ahal Region", "Ashgabat", "Balkan Region", "Daşoguz Region", "Lebap Region", "Mary Region"]
    }, {name: "Turks and Caicos Islands", states: []}, {
        name: "Tuvalu",
        states: ["Funafuti", "Nanumanga", "Nanumea", "Niutao Island Council", "Nui", "Nukufetau", "Nukulaelae", "Vaitupu"]
    }, {
        name: "Uganda",
        states: ["Abim District", "Adjumani District", "Agago District", "Alebtong District", "Amolatar District", "Amudat District", "Amuria District", "Amuru District", "Apac District", "Arua District", "Budaka District", "Bududa District", "Bugiri District", "Buhweju District", "Buikwe District", "Bukedea District", "Bukomansimbi District", "Bukwo District", "Bulambuli District", "Buliisa District", "Bundibugyo District", "Bunyangabu District", "Bushenyi District", "Busia District", "Butaleja District", "Butambala District", "Butebo District", "Buvuma District", "Buyende District", "Central Region", "Dokolo District", "Eastern Region", "Gomba District", "Gulu District", "Ibanda District", "Iganga District", "Isingiro District", "Jinja District", "Kaabong District", "Kabale District", "Kabarole District", "Kaberamaido District", "Kagadi District", "Kakumiro District", "Kalangala District", "Kaliro District", "Kalungu District", "Kampala District", "Kamuli District", "Kamwenge District", "Kanungu District", "Kapchorwa District", "Kasese District", "Katakwi District", "Kayunga District", "Kibaale District", "Kiboga District", "Kibuku District", "Kiruhura District", "Kiryandongo District", "Kisoro District", "Kitgum District", "Koboko District", "Kole District", "Kotido District", "Kumi District", "Kween District", "Kyankwanzi District", "Kyegegwa District", "Kyenjojo District", "Kyotera District", "Lamwo District", "Lira District", "Luuka District", "Luwero District", "Lwengo District", "Lyantonde District", "Manafwa District", "Maracha District", "Masaka District", "Masindi District", "Mayuge District", "Mbale District", "Mbarara District", "Mitooma District", "Mityana District", "Moroto District", "Moyo District", "Mpigi District", "Mubende District", "Mukono District", "Nakapiripirit District", "Nakaseke District", "Nakasongola District", "Namayingo District", "Namisindwa District", "Namutumba District", "Napak District", "Nebbi District", "Ngora District", "Northern Region", "Ntoroko District", "Ntungamo District", "Nwoya District", "Omoro District", "Otuke District", "Oyam District", "Pader District", "Pakwach District", "Pallisa District", "Rakai District", "Rubanda District", "Rubirizi District", "Rukiga District", "Rukungiri District", "Sembabule District", "Serere District", "Sheema District", "Sironko District", "Soroti District", "Tororo District", "Wakiso District", "Western Region", "Yumbe District", "Zombo District"]
    }, {
        name: "Ukraine",
        states: ["Autonomous Republic of Crimea", "Cherkaska oblast", "Chernihivska oblast", "Chernivetska oblast", "Dnipropetrovska oblast", "Donetska oblast", "Ivano-Frankivska oblast", "Kharkivska oblast", "Khersonska oblast", "Khmelnytska oblast", "Kirovohradska oblast", "Kyiv", "Kyivska oblast", "Luhanska oblast", "Lvivska oblast", "Mykolaivska oblast", "Odeska oblast", "Poltavska oblast", "Rivnenska oblast", "Sevastopol", "Sumska oblast", "Ternopilska oblast", "Vinnytska oblast", "Volynska oblast", "Zakarpatska Oblast", "Zaporizka oblast", "Zhytomyrska oblast"]
    }, {
        name: "United Arab Emirates",
        states: ["Abu Dhabi Emirate", "Ajman Emirate", "Dubai", "Fujairah", "Ras al-Khaimah", "Sharjah Emirate", "Umm al-Quwain"]
    }, {
        name: "United Kingdom",
        states: ["Aberdeen", "Aberdeenshire", "Angus", "Antrim", "Antrim and Newtownabbey", "Ards", "Ards and North Down", "Argyll and Bute", "Armagh City and District Council", "Armagh, Banbridge and Craigavon", "Ascension Island", "Ballymena Borough", "Ballymoney", "Banbridge", "Barnsley", "Bath and North East Somerset", "Bedford", "Belfast district", "Birmingham", "Blackburn with Darwen", "Blackpool", "Blaenau Gwent County Borough", "Bolton", "Bournemouth", "Bracknell Forest", "Bradford", "Bridgend County Borough", "Brighton and Hove", "Buckinghamshire", "Bury", "Caerphilly County Borough", "Calderdale", "Cambridgeshire", "Carmarthenshire", "Carrickfergus Borough Council", "Castlereagh", "Causeway Coast and Glens", "Central Bedfordshire", "Ceredigion", "Cheshire East", "Cheshire West and Chester", "City and County of Cardiff", "City and County of Swansea", "City of Bristol", "City of Derby", "City of Kingston upon Hull", "City of Leicester", "City of London", "City of Nottingham", "City of Peterborough", "City of Plymouth", "City of Portsmouth", "City of Southampton", "City of Stoke-on-Trent", "City of Sunderland", "City of Westminster", "City of Wolverhampton", "City of York", "Clackmannanshire", "Coleraine Borough Council", "Conwy County Borough", "Cookstown District Council", "Cornwall", "County Durham", "Coventry", "Craigavon Borough Council", "Cumbria", "Darlington", "Denbighshire", "Derbyshire", "Derry City and Strabane", "Derry City Council", "Devon", "Doncaster", "Dorset", "Down District Council", "Dudley", "Dumfries and Galloway", "Dundee", "Dungannon and South Tyrone Borough Council", "East Ayrshire", "East Dunbartonshire", "East Lothian", "East Renfrewshire", "East Riding of Yorkshire", "East Sussex", "Edinburgh", "England", "Essex", "Falkirk", "Fermanagh and Omagh", "Fermanagh District Council", "Fife", "Flintshire", "Gateshead", "Glasgow", "Gloucestershire", "Gwynedd", "Halton", "Hampshire", "Hartlepool", "Herefordshire", "Hertfordshire", "Highland", "Inverclyde", "Isle of Wight", "Isles of Scilly", "Kent", "Kirklees", "Knowsley", "Lancashire", "Larne Borough Council", "Leeds", "Leicestershire", "Limavady Borough Council", "Lincolnshire", "Lisburn and Castlereagh", "Lisburn City Council", "Liverpool", "London Borough of Barking and Dagenham", "London Borough of Barnet", "London Borough of Bexley", "London Borough of Brent", "London Borough of Bromley", "London Borough of Camden", "London Borough of Croydon", "London Borough of Ealing", "London Borough of Enfield", "London Borough of Hackney", "London Borough of Hammersmith and Fulham", "London Borough of Haringey", "London Borough of Harrow", "London Borough of Havering", "London Borough of Hillingdon", "London Borough of Hounslow", "London Borough of Islington", "London Borough of Lambeth", "London Borough of Lewisham", "London Borough of Merton", "London Borough of Newham", "London Borough of Redbridge", "London Borough of Richmond upon Thames", "London Borough of Southwark", "London Borough of Sutton", "London Borough of Tower Hamlets", "London Borough of Waltham Forest", "London Borough of Wandsworth", "Magherafelt District Council", "Manchester", "Medway", "Merthyr Tydfil County Borough", "Metropolitan Borough of Wigan", "Mid and East Antrim", "Mid Ulster", "Middlesbrough", "Midlothian", "Milton Keynes", "Monmouthshire", "Moray", "Moyle District Council", "Neath Port Talbot County Borough", "Newcastle upon Tyne", "Newport", "Newry and Mourne District Council", "Newry, Mourne and Down", "Newtownabbey Borough Council", "Norfolk", "North Ayrshire", "North Down Borough Council", "North East Lincolnshire", "North Lanarkshire", "North Lincolnshire", "North Somerset", "North Tyneside", "North Yorkshire", "Northamptonshire", "Northern Ireland", "Northumberland", "Nottinghamshire", "Oldham", "Omagh District Council", "Orkney Islands", "Outer Hebrides", "Oxfordshire", "Pembrokeshire", "Perth and Kinross", "Poole", "Powys", "Reading", "Redcar and Cleveland", "Renfrewshire", "Rhondda Cynon Taf", "Rochdale", "Rotherham", "Royal Borough of Greenwich", "Royal Borough of Kensington and Chelsea", "Royal Borough of Kingston upon Thames", "Rutland", "Saint Helena", "Salford", "Sandwell", "Scotland", "Scottish Borders", "Sefton", "Sheffield", "Shetland Islands", "Shropshire", "Slough", "Solihull", "Somerset", "South Ayrshire", "South Gloucestershire", "South Lanarkshire", "South Tyneside", "Southend-on-Sea", "St Helens", "Staffordshire", "Stirling", "Stockport", "Stockton-on-Tees", "Strabane District Council", "Suffolk", "Surrey", "Swindon", "Tameside", "Telford and Wrekin", "Thurrock", "Torbay", "Torfaen", "Trafford", "United Kingdom", "Vale of Glamorgan", "Wakefield", "Wales", "Walsall", "Warrington", "Warwickshire", "West Berkshire", "West Dunbartonshire", "West Lothian", "West Sussex", "Wiltshire", "Windsor and Maidenhead", "Wirral", "Wokingham", "Worcestershire", "Wrexham County Borough"]
    }, {
        name: "United States Minor Outlying Islands",
        states: ["Baker Island", "Howland Island", "Jarvis Island", "Johnston Atoll", "Kingman Reef", "Midway Islands", "Navassa Island", "Palmyra Atoll", "Wake Island"]
    }, {
        name: "Uruguay",
        states: ["Artigas", "Canelones", "Cerro Largo", "Colonia", "Durazno", "Flores", "Florida", "Lavalleja", "Maldonado", "Montevideo", "Paysandú", "Río Negro", "Rivera", "Rocha", "Salto", "San José", "Soriano", "Tacuarembó", "Treinta y Tres"]
    }, {
        name: "Uzbekistan",
        states: ["Andijan Region", "Bukhara Region", "Fergana Region", "Jizzakh Region", "Karakalpakstan", "Namangan Region", "Navoiy Region", "Qashqadaryo Region", "Samarqand Region", "Sirdaryo Region", "Surxondaryo Region", "Tashkent", "Tashkent Region", "Xorazm Region"]
    }, {
        name: "Vanuatu",
        states: ["Malampa", "Penama", "Sanma", "Shefa", "Tafea", "Torba"]
    }, {name: "Vatican City State (Holy See)", states: []}, {
        name: "Venezuela",
        states: ["Amazonas", "Anzoátegui", "Apure", "Aragua", "Barinas", "Bolívar", "Carabobo", "Cojedes", "Delta Amacuro", "Distrito Capital", "Falcón", "Federal Dependencies of Venezuela", "Guárico", "La Guaira", "Lara", "Mérida", "Miranda", "Monagas", "Nueva Esparta", "Portuguesa", "Sucre", "Táchira", "Trujillo", "Yaracuy", "Zulia"]
    }, {
        name: "Vietnam",
        states: ["An Giang", "Bà Rịa-Vũng Tàu", "Bắc Giang", "Bắc Kạn", "Bạc Liêu", "Bắc Ninh", "Bến Tre", "Bình Dương", "Bình Định", "Bình Phước", "Bình Thuận", "Cà Mau", "Cần Thơ", "Cao Bằng", "Đà Nẵng", "Đắk Lắk", "Đắk Nông", "Điện Biên", "Đồng Nai", "Đồng Tháp", "Gia Lai", "Hà Giang", "Hà Nam", "Hà Nội", "Hà Tĩnh", "Hải Dương", "Hải Phòng", "Hậu Giang", "Hồ Chí Minh", "Hòa Bình", "Hưng Yên", "Khánh Hòa", "Kiên Giang", "Kon Tum", "Lai Châu", "Lâm Đồng", "Lạng Sơn", "Lào Cai", "Long An", "Nam Định", "Nghệ An", "Ninh Bình", "Ninh Thuận", "Phú Thọ", "Phú Yên", "Quảng Bình", "Quảng Nam", "Quảng Ngãi", "Quảng Ninh", "Quảng Trị", "Sóc Trăng", "Sơn La", "Tây Ninh", "Thái Bình", "Thái Nguyên", "Thanh Hóa", "Thừa Thiên-Huế", "Tiền Giang", "Trà Vinh", "Tuyên Quang", "Vĩnh Long", "Vĩnh Phúc", "Yên Bái"]
    }, {name: "Virgin Islands (British)", states: []}, {
        name: "Virgin Islands (US)",
        states: ["Saint Croix", "Saint John", "Saint Thomas"]
    }, {name: "Wallis and Futuna Islands", states: []}, {name: "Western Sahara", states: []}, {
        name: "Yemen",
        states: ["'Adan", "'Amran", "Abyan", "Al Bayda'", "Al Hudaydah", "Al Jawf", "Al Mahrah", "Al Mahwit", "Amanat Al Asimah", "Dhamar", "Hadhramaut", "Hajjah", "Ibb", "Lahij", "Ma'rib", "Raymah", "Saada", "Sana'a", "Shabwah", "Socotra", "Ta'izz"]
    }, {
        name: "Zambia",
        states: ["Central Province", "Copperbelt Province", "Eastern Province", "Luapula Province", "Lusaka Province", "Muchinga Province", "Northern Province", "Northwestern Province", "Southern Province", "Western Province"]
    }, {
        name: "Zimbabwe",
        states: ["Bulawayo Province", "Harare Province", "Manicaland", "Mashonaland Central Province", "Mashonaland East Province", "Mashonaland West Province", "Masvingo Province", "Matabeleland North Province", "Matabeleland South Province", "Midlands Province"]
    }],
    states: {
        us: [
            {
                name: "Alabama",
                abbreviation: "AL"
            },
            {
                name: "Alaska",
                abbreviation: "AK"
            },
            {
                name: "Arkansas",
                abbreviation: "AR"
            },
            {
                name: "American Samoa",
                abbreviation: "AS"
            },
            {
                name: "Arizona",
                abbreviation: "AZ"
            },

            {
                name: "California",
                abbreviation: "CA"
            },
            {
                name: "Colorado",
                abbreviation: "CO"
            },
            {
                name: "Connecticut",
                abbreviation: "CT"
            },
            {
                name: "District Of Columbia",
                abbreviation: "DC"
            },
            {
                name: "Delaware",
                abbreviation: "DE"
            },
            {
                name: "Florida",
                abbreviation: "FL"
            },
            {
                name: "Federated States Of Micronesia",
                abbreviation: "FM"
            },
            {
                name: "Georgia",
                abbreviation: "GA"
            },
            {
                name: "Guam",
                abbreviation: "GU"
            },
            {
                name: "Hawaii",
                abbreviation: "HI"
            },
            {
                name: "Iowa",
                abbreviation: "IA"
            },
            {
                name: "Idaho",
                abbreviation: "ID"
            },
            {
                name: "Illinois",
                abbreviation: "IL"
            },
            {
                name: "Indiana",
                abbreviation: "IN"
            },
            {
                name: "Kansas",
                abbreviation: "KS"
            },
            {
                name: "Kentucky",
                abbreviation: "KY"
            },
            {
                name: "Louisiana",
                abbreviation: "LA"
            },
            {
                name: "Massachusetts",
                abbreviation: "MA"
            },
            {
                name: "Maryland",
                abbreviation: "MD"
            },
            {
                name: "Maine",
                abbreviation: "ME"
            },
            {
                name: "Marshall Islands",
                abbreviation: "MH"
            },
            {
                name: "Michigan",
                abbreviation: "MI"
            },
            {
                name: "Minnesota",
                abbreviation: "MN"
            },
            {
                name: "Missouri",
                abbreviation: "MO"
            },
            {
                name: "Mississippi",
                abbreviation: "MS"
            },
            {
                name: "Montana",
                abbreviation: "MT"
            },
            {
                name: "North Carolina",
                abbreviation: "NC"
            },
            {
                name: "North Dakota",
                abbreviation: "ND"
            },
            {
                name: "Nebraska",
                abbreviation: "NE"
            },
            {
                name: "New Hampshire",
                abbreviation: "NH"
            },
            {
                name: "New Jersey",
                abbreviation: "NJ"
            },
            {
                name: "New Mexico",
                abbreviation: "NM"
            },
            {
                name: "Nevada",
                abbreviation: "NV"
            },
            {
                name: "New York",
                abbreviation: "NY"
            },
            {
                name: "Northern Mariana Islands",
                abbreviation: "MP"
            },
            {
                name: "Ohio",
                abbreviation: "OH"
            },
            {
                name: "Oklahoma",
                abbreviation: "OK"
            },
            {
                name: "Oregon",
                abbreviation: "OR"
            },
            {
                name: "Pennsylvania",
                abbreviation: "PA"
            },
            {
                name: "Puerto Rico",
                abbreviation: "PR"
            },
            {
                name: "Palau",
                abbreviation: "PW"
            },
            {
                name: "Rhode Island",
                abbreviation: "RI"
            },
            {
                name: "South Carolina",
                abbreviation: "SC"
            },
            {
                name: "South Dakota",
                abbreviation: "SD"
            },
            {
                name: "Tennessee",
                abbreviation: "TN"
            },
            {
                name: "Texas",
                abbreviation: "TX"
            },
            {
                name: "Utah",
                abbreviation: "UT"
            },
            {
                name: "Virginia",
                abbreviation: "VA"
            },
            {
                name: "Virgin Islands",
                abbreviation: "VI"
            },
            {
                name: "Vermont",
                abbreviation: "VT"
            },
            {
                name: "Washington",
                abbreviation: "WA"
            },
            {
                name: "Wisconsin",
                abbreviation: "WI"
            },
            {
                name: "West Virginia",
                abbreviation: "WV"
            },
            {
                name: "Wyoming",
                abbreviation: "WY"
            }
        ],
        ca: [{
            name: 'Alberta',
            abbreviation: 'AB'
        }, {
            name: 'British Columbia',
            abbreviation: 'BC'
        }, {
            name: 'Manitoba',
            abbreviation: 'MB'
        }, {
            name: 'New Brunswick',
            abbreviation: 'NB'
        }, {
            name: 'Newfoundland and Labrador',
            abbreviation: 'NL'
        }, {
            name: 'Northwest Territories',
            abbreviation: 'NT'
        }, {
            name: 'Nova Scotia',
            abbreviation: 'NS'
        }, {
            name: 'Nunavut',
            abbreviation: 'NU'
        }, {
            name: 'Ontario',
            abbreviation: 'ON'
        }, {
            name: 'Prince Edward Island',
            abbreviation: 'PE'
        }, {
            name: 'Quebec',
            abbreviation: 'QC'
        }, {
            name: 'Saskatchewan',
            abbreviation: 'SK'
        }, {
            name: 'Yukon Territory',
            abbreviation: 'YT'
        }]
    },
    statusCodes: {
        GONE: 410
    }
};

PJQ.constants.colors = {
    BLUE: '#007bff',
    INDIGO: '#6610f2',
    PURPLE: '#6f42c1',
    PINK: '#e83e8c',
    RED: '#dc3545',
    ORANGE: '#fd7e14',
    YELLOW: '#ffc107',
    GREEN: '#4CAF50',
    TEAL: '#20c997',
    CYAN: '#17a2b8',
    WHITE: '#fff',
    GRAY: '#6c757d',
    DARK: '#343a40',
    BLACK: "#000000"
};

PJQ.constants.navigation = {
    categories: {
        FIELD_TOOLS: 1,
        BIDDING: 2,
        JOB_COSTING: 3
    },
    categoryNames: {
        1: 'Field Tools',
        2: 'Bidding',
        3: 'Job Costing'
    }
}

PJQ.constants.bidFormHelpers = {
    lineItemTypes: [
        {name: "Sum", abbreviation: "Sum"},
        {name: "Each", abbreviation: "Ea."},
        {name: "Square Feet", abbreviation: "Sq.Ft."},
        {name: "Linear Feet", abbreviation: "Ln.Ft."},
        {name: "Cubic Feet", abbreviation: "Cu.Ft."},
        {name: "Square Yards", abbreviation: "Sq.Yd."},
        {name: "Linear Yards", abbreviation: "Ln.Yd."},
        {name: "Cubic Yards", abbreviation: "Cu.Yd."},
        {name: "Acres", abbreviation: "Acres"},
        {name: "Hours", abbreviation: "Hrs"},
        {name: "Days", abbreviation: "Days"},
        {name: "Pounds", abbreviation: "Lbs."},
        {name: "Tons", abbreviation: "Tons"}
    ],
    acknowledgementTypes: [
        "Yes/No",
        "Text",
        "Money",
        "Numeric",
        "Single Choice",
        "Multiple Choice",
        "Date",
        "Date/Time"
    ],
    bondingTypes: [
        "Yes/No",
        "Text",
        "Money",
        "Numeric",
        "Single Choice",
        "Multiple Choice",
        "Date",
        "Date/Time"
    ],
    certificationTypes: [
        "Yes/No",
        "Text",
        "Money",
        "Numeric",
        "Single Choice",
        "Multiple Choice",
        "Date",
        "Date/Time"
    ],
    laborRateTypes: [
        "Yes/No",
        "Text",
        "Money",
        "Numeric",
        "Single Choice",
        "Multiple Choice",
        "Date",
        "Date/Time"
    ],
    proposalLevelColors: [
        'bddcff',
        'ffc7c7',
        'f8e286',
        'afecb1',
        'e2cdff'
    ]
};

PJQ.constants.primeContracts = {
    primeContractStatus: {
        DRAFT: 1,
        OUT_FOR_BID: 2,
        OUT_FOR_SIGNATURE: 3,
        APPROVED: 4,
        COMPLETE: 5,
        TERMINATED: 6
    },
    primeContractStatusNames: {
        1: 'Draft',
        2: 'Out for Bid',
        3: 'Out for Signature',
        4: 'Approved',
        5: 'Complete',
        6: 'Terminated'
    },
    changeOrderStatus: {
        DRAFT: 0,
        NO_CHARGE: 1,
        IN_REVIEW: 2,
        NOT_PRICING: 3,
        PRICING: 4,
        NOT_PROCEEDING: 5,
        PROCEEDING: 6,
        REVISED: 7,
        APPROVED: 8,
        REJECTED: 9,
        VOID: 10
    },
    primeContractStatusBuckets: {
        PENDING: {
            name: "Pending",
            statuses: [2, 3]
        },
        PROJECTED: {
            name: "Projected",
            statuses: [2, 3, 4, 5]
        },
        APPROVED: {
            name: "Approved",
            statuses: [4, 5]
        }
    },
    changeOrderStatusNames: {
        0: 'Draft',
        1: 'No Charge',
        2: 'In Review',
        3: 'Not Pricing',
        4: 'Pricing',
        5: 'Not Proceeding',
        6: 'Proceeding',
        7: 'Revised',
        8: 'Approved',
        9: 'Rejected',
        10: 'Void'
    },
    changeOrderStatusBuckets: {
        PENDING: {
            name: "Pending",
            statuses: [2, 4, 6, 7, 9]
        },
        PROJECTED: {
            name: "Projected",
            statuses: [2, 4, 6, 7, 8]
        },
        APPROVED: {
            name: "Approved",
            statuses: [8]
        }
    },
    view: {
        PRIME_CONTRACTS: "primecontracts",
        CHANGE_ORDERS: "changeorders"
    },
    filterType: {
        PRIME_CONTRACT_STATUS_FILTER: "primeContractStatusFilter"
    },
    changeOrderFilterType: {
        STATUS_FILTER: "statusFilter"
    }
}

PJQ.constants.financeCoreFields = {
    primeContacts: {
        primeContract: [
            {
                name: "Number",
                fieldName: "number",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Default Work Retainage",
                fieldName: "defaultWorkRetainagePercent",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Default Material Retainage",
                fieldName: "defaultMaterialRetainagePercent",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Terms",
                fieldName: "termsId",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Description",
                fieldName: "description",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Start Date",
                fieldName: "startOn",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Estimated Completion Date",
                fieldName: "estimatedCompleteOn",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Substantial Completion Date",
                fieldName: "substantialCompleteOn",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Actual Completion Date",
                fieldName: "actualCompleteOn",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Contract Date",
                fieldName: "contractOn",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Signed Contract Received Date",
                fieldName: "signedContractOn",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Letter of Intent Date",
                fieldName: "letterOfIntentOn",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Approval Letter Date",
                fieldName: "approvalLetterOn",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Issued On Date",
                fieldName: "issuedOn",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Execution Date",
                fieldName: "executedOn",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Returned Date",
                fieldName: "returnedOn",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Contract Termination Date",
                fieldName: "contractTerminatedOn",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Inclusions",
                fieldName: "inclusions",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Exclusions",
                fieldName: "exclusions",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Signed Documents",
                fieldName: "signedDocumentAttachments",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Executed Documents",
                fieldName: "executedDocumentAttachments",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Attachments",
                fieldName: "attachments",
                isVisible: true,
                isRequired: false
            }
        ],
        changeOrder: [
            {
                name: "Reviewer",
                fieldName: "reviewer"
            },
            {
                name: "Received From",
                fieldName: "receivedFromId"
            },
            {
                name: "Number",
                fieldName: "number"
            },
            {
                name: "Executed",
                fieldName: "executed"
            },
            {
                name: "Field Change",
                fieldName: "fieldChange"
            },
            {
                name: "Paid In Full",
                fieldName: "paidInFull"
            },
            {
                name: "Change Reason",
                fieldName: "changeReason"
            },
            {
                name: "Invoiced Date",
                fieldName: "invoicedDate"
            },
            {
                name: "Due Date",
                fieldName: "dueDate"
            },
            {
                name: "Description",
                fieldName: "description"
            },
            {
                name: "Attachments",
                fieldName: "attachments"
            }
        ]
    },
    commitments: {
        commitment: [
            {
                name: "Invoice Contact",
                fieldName: "invoiceContactId",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Number",
                fieldName: "number",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Title",
                fieldName: "title",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Default Work Retainage",
                fieldName: "defaultWorkRetainagePercent",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Default Material Retainage",
                fieldName: "defaultMaterialRetainagePercent",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Ship To",
                fieldName: "shipToId",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Bill To",
                fieldName: "billToId",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Terms",
                fieldName: "termsId",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Description",
                fieldName: "description",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Start Date",
                fieldName: "startDate",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Estimated Completion Date",
                fieldName: "estimatedCompletionDate",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Actual Completion Date",
                fieldName: "actualCompletionDate",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Contract Date",
                fieldName: "contractDate",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Signed Contract Received Date",
                fieldName: "signedContractReceivedDate",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Letter of Intent Date",
                fieldName: "letterOfIntentDate",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Approval Letter Date",
                fieldName: "approvalLetterDate",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Issued On Date",
                fieldName: "issuedOnDate",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Execution Date",
                fieldName: "executionDate",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Returned Date",
                fieldName: "returnedDate",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Inclusions",
                fieldName: "inclusions",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Exclusions",
                fieldName: "exclusions",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Certificate of Insurance",
                fieldName: "coiAttachments",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Delivery Date",
                fieldName: "deliveryDate",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Payment Terms",
                fieldName: "paymentTerms",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Shipping Terms",
                fieldName: "shipVia",
                isVisible: true,
                isRequired: false
            },
            {
                name: "W9",
                fieldName: "w9Attachments",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Lien Waivers",
                fieldName: "lienWaiverAttachments",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Signed Documents",
                fieldName: "signedDocumentAttachments",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Affidavits",
                fieldName: "affidavitAttachments",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Executed Documents",
                fieldName: "executedDocumentAttachments",
                isVisible: true,
                isRequired: false
            },
            {
                name: "Attachments",
                fieldName: "attachments",
                isVisible: true,
                isRequired: false
            }
        ],
        changeOrder: [
            {
                name: "Reviewer",
                fieldName: "reviewer"
            },
            {
                name: "Received From",
                fieldName: "receivedFromId"
            },
            {
                name: "Number",
                fieldName: "number"
            },
            {
                name: "Executed",
                fieldName: "executed"
            },
            {
                name: "Field Change",
                fieldName: "fieldChange"
            },
            {
                name: "Paid In Full",
                fieldName: "paidInFull"
            },
            {
                name: "Change Reason",
                fieldName: "changeReason"
            },
            {
                name: "Invoiced Date",
                fieldName: "invoicedDate"
            },
            {
                name: "Due Date",
                fieldName: "dueDate"
            },
            {
                name: "Description",
                fieldName: "description"
            },
            {
                name: "Attachments",
                fieldName: "attachments"
            }
        ]
    },
    invoices: {
        payableInvoice: [
            {
                name: "Invoice #",
                fieldName: "number"
            },
            {
                name: "Paid",
                fieldName: "paid"
            },
            {
                name: "Notes",
                fieldName: "notes"
            },
            {
                name: "Certificate of Insurance",
                fieldName: "coiAttachments"
            },
            {
                name: "W9",
                fieldName: "w9Attachments"
            },
            {
                name: "Lien Waivers",
                fieldName: "lienWaiverAttachments"
            },
            {
                name: "Attachments",
                fieldName: "attachments"
            }
        ],
        receivableInvoice: [
            {
                name: "Invoice #",
                fieldName: "number"
            },
            {
                name: "Paid",
                fieldName: "paid"
            },
            {
                name: "Notes",
                fieldName: "notes"
            },

            {
                name: "Attachments",
                fieldName: "attachments"
            }
        ]
    },
    directCosts: {
        directCost: [
            {
                name: "Vendor",
                fieldName: "vendor"
            },
            {
                name: "Reported By",
                fieldName: "reportedBy"
            },
            {
                name: "Type",
                fieldName: "type"
            },
            {
                name: "Applied On",
                fieldName: "appliedOn"
            },
            {
                name: "Received On",
                fieldName: "receivedOn"
            },
            {
                name: "Paid On",
                fieldName: "paidOn"
            },
            {
                name: "Terms",
                fieldName: "terms"
            },
            {
                name: "Description",
                fieldName: "description"
            },
            {
                name: "Attachments",
                fieldName: "attachments"
            }
        ]
    }
};

PJQ.constants.primeContractChangeOrders = {
    status: {
        DRAFT: 1,
        NO_CHARGE: 2,
        IN_REVIEW: 3,
        NOT_PRICING: 4,
        PRICING: 5,
        NOT_PROCEEDING: 6,
        PROCEEDING: 7,
        REVISED: 8,
        APPROVED: 9,
        REJECTED: 10,
        VOID: 11
    },
    statusNames: {
        1: 'Draft',
        2: 'No Charge',
        3: 'In Review',
        4: 'Not Pricing',
        5: 'Pricing',
        6: 'Not Proceeding',
        7: 'Proceeding',
        8: 'Revised',
        9: 'Approved',
        10: 'Rejected',
        11: 'Void'
    }
};

PJQ.constants.invoicing = {
    payableInvoiceStatus: {
        DRAFT: 0,
        REVIEWING: 1,
        REVISE: 2,
        APPROVED: 3,
        COMPLETE: 4,
        VOID: 5
    },
    payableInvoiceStatusNames: {
        0: 'Draft',
        1: 'Under Review',
        2: 'Revise',
        3: 'Approved',
        4: 'Complete',
        5: 'Void'
    },
    inviteStatus: {
        'DECLINED': 0,
        'ACCEPTED': 1
    },
    receivableInvoiceStatus: {
        DRAFT: 0,
        REVIEWING: 1,
        REVISE: 2,
        APPROVED: 3,
        COMPLETE: 4
    },
    receivableInvoiceStatusNames: {
        0: 'Draft',
        1: 'Under Review',
        2: 'Revise',
        3: 'Approved',
        4: 'Complete'
    },
    filterType: {
        STATUS_FILTER: 'statusFilter'
    },
    view: {
        PAYABLE_INVOICES: "payableinvoices",
        RECEIVABLE_INVOICES: "receivableinvoices"
    },
    paymentMethods: [
        'Credit Card',
        'Check',
        'Electronic'
    ]
};

PJQ.constants.directcosts = {
    directCostType: {
        EXPENSE: 1,
        INVOICE: 2,
        PAYROLL: 3
    },
    directCostTypeNames: {
        1: 'Expense',
        2: 'Invoice',
        3: 'Payroll'
    },
    directCostStatus: {
        DRAFT: 1,
        PENDING: 2,
        REVISE: 3,
        APPROVED: 4
    },
    directCostStatusNames: {
        1: 'Draft',
        2: 'Pending',
        3: 'Revise',
        4: 'Approved'
    },
    filterType: {
        DIRECT_COST_TYPE_FILTER: 'directCostTypeFilter',
        DIRECT_COST_STATUS_FILTER: 'directCostStatusFilter'
    },
    view: {
        DIRECT_COSTS: "directcosts"
    }
};

PJQ.constants.projectContacts = {
    bidStatus: {
        PENDING: 'PENDING',
        DECLINE: 'DECLINE',
        ACCEPT: 'ACCEPT',
        BID_RECEIVED: 'BID RECEIVED',
        AWARDED: 'AWARDED'
    }
};

PJQ.constants.markup = {
    requiredAst: '<span class="text-danger">*</span>'
};

PJQ.constants.localStorage = {
    MY_PROJECT_LIST_FILTER: `MY_PROJECT_LIST_FILTER`,
    BID_FORM_PROPOSAL_SORT: "BID_FORM_PROPOSAL_SORT",
}

PJQ.constants.cookies = {
    ACTION_ITEM_ORDER_COOKIE: "11236b4e-6da4-4576-98f5-981e8a30b385",
    CLOSE_PREQUAL_HELP_ALERT: "4343fee1-dcf7-487d-bf4d-7ab33976eef8",
    NOTIFY_CONTACT_GROUPS_REPORTED: "2f1c6d7f-1f6a-4a8e-9bee-aaa4153e1116",
    NOTIFY_DAILY_REPORTS_PROJECT_START_END: "0a71555e-3244-4e9d-b94c-cbf4234d56d6",
    PROJECT_INVITES_FAVORITE_FILTER: "PROJECT_INVITES_FAVORITE_FILTER",
    PROJECT_INVITES_CURRENT_BIDDING_FILTER: "PROJECT_INVITES_CURRENT_BIDDING_FILTER",
    PROJECT_INVITES_ORDER_COOKIE: "091ca838-72c2-4f0c-a219-90a65159c75e",
    SCHEDULE_TEMPLATE_DATES_ORIGIN: "f100ed94-6a16-40c9-8ace-7718a2c0ee4b",
    RFI_PAGE_LENGTH: "3F156499-1584-4152-9BE7-216A933B03A5",
    SCHEDULE_TASK_LIST_GROUP_BY: "3F156499-1584-4152-9BE7-216A933B03A5",
    SUBSCRIPTION_FREE_TRIAL: "97ebfdec-ba47-4c21-84a7-1009f4a4cb32",
    SUBSCRIPTION_EXPIRES_ALERT: "c649a742-859f-4096-b6cf-f9aa57951b43",
    SUBMITTAL_ORDER_COOKIE: "f78a796d-cfda-4ba1-acf3-1ae2f8c15446",
    PUNCHLIST_ORDER_COOKIE: "f3e968f2-bcaf-49a1-9cc1-cceae3824ca8",
    INSPECTIONS_ORDER_COOKIE: "dbf2eec6-e4da-442b-9795-118d0ff99966",
    INSPECTIONS_GROUP_BY_KEY: "inspections_group_by",
    PRODUCTION_QUANTITIES_ORDER_COOKIE: "b2f32e3a-c94f-4bd3-b771-e96905bcca6b",
    NOTIFY_PREQUAL_VIEW_REQUESTED: "cf6adedb-ca86-4477-86bb-4728679b2041",
    NOTIFY_DRAWING_SHARE_PREVENT_EXPIRE: "65524272-cb10-40ab-a22f-952ce70c451f",
    ALERT_DRAWING_SHARE_PREVENT_EXPIRE: "65524272-cb10-40ab-a22f-952ce70c451f",
    ENABLE_CONSECUTIVE_DRAWING_ANNOTATIONS: "ENABLE_CONSECUTIVE_DRAWING_ANNOTATIONS",
    SCHEDULE_GANTT_SORT_COLUMN: "40a8d697-9043-4fbb-ab82-2c74e80a3378",
    SCHEDULE_GANTT_SORT_DIRECTION: "6c4475a4-8dbc-475d-8517-d8573e5024c0",
    SCHEDULE_TASK_LIST_ORDER: "b834b7c5-8ddb-49bd-a972-6f57bb4e32e0",
    PROJECT_CONTACT_LIST_PAGE_LENGTH: "4f97ff02-e73d-437a-abec-d8bef4d4a7dc",
    COMMITMENT_LIST_COLUMNS_WIDTH: "998db2bb-00e1-4516-859f-47b06c540046",
    MY_PROJECTS_LIST_COLUMNS_WIDTH: "8efccf80-0aa4-46a0-89cf-2eadca8ca897",
    PROJECT_INVITES_LIST_COLUMNS_WIDTH: "06b506e3-5006-43a3-a5bd-0bf6e7cb9077",
    PRODUCTION_QUANTITIES_COLUMNS_WIDTH: "7bd78c30-b8d7-4810-a3f0-c98dea1e52dd"
};

PJQ.constants.changeRequests = {
    changeRequestStatus: {
        DRAFT: 0,
        NO_CHARGE: 1,
        IN_REVIEW: 2,
        NOT_PRICING: 3,
        PRICING: 4,
        NOT_PROCEEDING: 5,
        PROCEEDING: 6,
        REVISED: 7,
        APPROVED: 8,
        REJECTED: 9,
        VOID: 10
    },
    changeRequestStatusNames: {
        0: 'Draft',
        1: 'No Charge',
        2: 'In Review',
        3: 'Not Pricing',
        4: 'Pricing',
        5: 'Not Proceeding',
        6: 'Proceeding',
        7: 'Revised',
        8: 'Approved',
        9: 'Rejected',
        10: 'Void'
    },
    scope: {
        OWNER_CHANGE: 0,
        INTERNAL: 1
    },
    scopeNames: {
        0: 'Owner Change',
        1: 'Internal'
    },
    revenueSource: {
        REVENUE: 0,
        MANUAL: 1
    },
    revenueSourceNames: {
        0: 'Revenue',
        1: 'Manual'
    },
    filterType: {
        STATUS_FILTER: 'statusFilter',
        OTHER_FILTER: 'other'
    },
    view: {
        CHANGE_REQUESTS: "changerequests"
    },
    changeRequestStatusBuckets: {
        PENDING: {
            name: "Pending",
            statuses: [2, 4, 6, 7, 9]
        },
        PROJECTED: {
            name: "Projected",
            statuses: [2, 4, 6, 7, 8]
        },
        APPROVED: {
            name: "Approved",
            statuses: [8]
        }
    },
};

PJQ.constants.rfq = {
    filterType: {
        STATUS_FILTER: 'statusFilter'
    }, rfqStatus: {
        DRAFT: 0,
        PRICING: 1,
        REVIEWING: 2,
        REVISE: 3,
        APPROVED: 4,
        CLOSED: 5
    },
    rfqStatusNames: {
        0: 'Draft',
        1: 'Pricing',
        2: 'Reviewing',
        3: 'Revise',
        4: 'Approved',
        5: 'Closed'
    },
    view: {
        RFQ: "rfq"
    }
}

PJQ.constants.commitments = {
    commitmentType: {
        PURCHASE_ORDER: 1,
        SUBCONTRACT: 2
    },
    commitmentTypeNames: {
        1: 'Purchase Order',
        2: 'Subcontract'
    },
    commitmentStatus: {
        DRAFT: 0,
        PURCHASE_ORDER_PROCESSING: 1,
        SUBCONTRACT_OUT_FOR_BID: 2,
        OUT_FOR_SIGNATURE: 3,
        SUBMITTED: 4,
        PURCHASE_ORDER_PARTIALLY_RECEIVED: 5,
        PURCHASE_ORDER_RECEIVED: 6,
        APPROVED: 7,
        SUBCONTRACT_COMPLETE: 8,
        SUBCONTRACT_TERMINATED: 9,
        SUBCONTRACT_VOID: 10,
        PURCHASE_ORDER_CLOSED: 11
    },
    commitmentStatusNames: {
        0: 'Draft',
        1: 'Processing',
        2: 'Out for Bid',
        3: 'Out for Signature',
        4: 'Submitted',
        5: 'Partially Received',
        6: 'Received',
        7: 'Approved',
        8: 'Complete',
        9: 'Terminated',
        10: 'Void',
        11: 'Closed'
    },
    commitmentStatusBuckets: {
        PENDING: {
            name: "Pending",
            statuses: [1, 2, 3, 4, 5, 6]
        },
        PROJECTED: {
            name: "Projected",
            statuses: [1, 2, 3, 4, 5, 6, 7, 8, 11]
        },
        COMMITTED: {
            name: "Committed",
            statuses: [7, 8, 11]
        }
    },
    changeOrderStatus: {
        DRAFT: 0,
        NO_CHARGE: 1,
        IN_REVIEW: 2,
        NOT_PRICING: 3,
        PRICING: 4,
        NOT_PROCEEDING: 5,
        PROCEEDING: 6,
        REVISED: 7,
        APPROVED: 8,
        REJECTED: 9,
        VOID: 10
    },
    changeOrderStatusNames: {
        0: 'Draft',
        1: 'No Charge',
        2: 'In Review',
        3: 'Not Pricing',
        4: 'Pricing',
        5: 'Not Proceeding',
        6: 'Proceeding',
        7: 'Revised',
        8: 'Approved',
        9: 'Rejected',
        10: 'Void'
    },
    changeOrderStatusBuckets: {
        PENDING: {
            name: "Pending",
            statuses: [2, 4, 6, 7]
        },
        PROJECTED: {
            name: "Projected",
            statuses: [2, 4, 6, 7, 8]
        },
        COMMITTED: {
            name: "Committed",
            statuses: [8]
        }
    },
    filterType: {
        TYPE_FILTER: 'typeFilter',
        STATUS_FILTER: 'statusFilter'
    },
    changeOrderFilterType: {
        STATUS_FILTER: 'statusFilter'
    },
    view: {
        COMMITMENTS: "commitments",
        CHANGE_ORDERS: "changeorders"
    },
    commitmentNumberTokenDateFormat: {
        MMDDYYYY: 0,
        MM: 1,
        DD: 2,
        YY: 3,
        YYYY: 4
    },
    commitmentNumberTokenDateFormatNames: [
        'Full Date',
        'Month',
        'Day',
        'Year 2-Digit',
        'Year'
    ],
    // TODO: this needs to be moved to the new customField
    customFieldType: {
        BOOLEAN: 1,
        CHOICE: 2,
        DATE: 3,
        DATETIME: 4,
        FILE: 5,
        INTEGER: 6,
        MONEY: 7,
        PERCENT: 8,
        TEXT: 9,
        TEXTAREA: 10
    }
};

PJQ.constants.regex = {
    CURRENCY_NO_SYMBOL: /(\d)(?=(\d\d\d)+(?!\d))/g
};

PJQ.constants.modules = {
    APP: 'APP',
    GLOBAL: 'GLOBAL',
    PROFILE_OLD: 'PJQPROFILE',
    PROFILE: 'PROFILE',
    ACTIONITEMS: 'ACTIONITEMS',
    BIDFORMS: 'BIDFORMS',
    PJQADDRESSBOOK: 'PJQADDRESSBOOK',
    ADDRESSBOOK: 'ADDRESSBOOK',
    PUBLICPROJECTS: 'PJQPUBLICPROJECTS',
    PROJECTWALL: 'PROJECTWALL',
    PROJECTWALLADMIN: 'PJQPROJECTWALLADMIN',
    PROJECTWALLSUB: 'PJQPROJECTWALLSUB',
    PROJECTLIST: 'PROJECTLIST',
    REPORTS: 'REPORTS',
    RFI: 'RFI',
    RESOURCES: 'RESOURCES',
    SUBMITTALS: 'SUBMITTALS',
    FIELDREPORTS: 'FIELDREPORTS',
    MARKUPTOOL: 'MARKUPTOOL',
    PUNCHLISTS: 'PUNCHLISTS',
    DAILYREPORTS: 'DAILYREPORTS',
    LOGIN: 'PJQLOGIN',
    ACCESS_KEY_LOGIN: 'PJQACCESSKEYLOGIN',
    PJQSETTINGS: 'PJQSETTINGS',
    SETTINGS: 'SETTINGS',
    SUBMITTALS: 'SUBMITTALS',
    PANTERASCHEDULE: 'PANTERASCHEDULE',
    DRAWINGS: 'DRAWINGS',
    BIDFILER: 'PJQBIDFILER',
    PRINTONDEMAND: 'PJQPRINTONDEMAND',
    PJQREGISTRATION: 'PJQREGISTRATION',
    FILES: 'FILES',
    SCHEDULE: 'SCHEDULE',
    TIMECARDS: 'TIMECARDS',
    INVOICES: 'INVOICES',
    BUDGET: 'BUDGET',
    COMMITMENTS: 'COMMITMENTS',
    PRIMECONTRACTS: 'PRIMECONTRACTS',
    DIRECTCOSTS: 'DIRECTCOSTS',
    INVOICING: 'INVOICING',
    MEETINGS: 'MEETINGS',
    INSPECTIONS: 'INSPECTIONS'
};

PJQ.constants.errorCodes = {
    DELETED_CONTACT: 100
};

PJQ.constants.auth = {
    minUsernameLength: 5,
    minPasswordLength: 5,
    login: {
        errorText: {
            INVALID_PASSWORD: 'The username or password you entered was incorrect.',
            USER_NOT_FOUND: 'The username you entered doesn\'t exist.'
        }
    }
};

PJQ.constants.screenings = {
    statuses: {
        WAITING: 1,
        UNUSED: 2,
        IN_PROCESS: 3,
        INCOMPLETE: 4,
        FEEDBACK_REQUIRED: 5,
        EXPIRED: 6,
        COMPLETE: 7,
        NOT_APPLICABLE: 8
    }
};
PJQ.constants.contacts = {
    contexts: {
        PARTICIPANTS: "PARTICIPANTS",
        CONTACTS: "CONTACTS",
        PROJECTCONTACTS: "PROJECTCONTACTS",
        USERS: "USERS",
        COMPANIES: "COMPANIES"
    }
};

PJQ.constants.customFields = {
    fieldTypes: {
        INT: 'INT',
        PERCENT: 'PERCENT',
        MONEY: 'MONEY',
        CALC: 'CALC',
        PHONE: 'PHONE',
        TEXT: 'TEXT',
        TEXTAREA: 'TEXTAREA',
        BOOL: 'BOOL',
        CHOICE: 'CHOICE',
        GRID: 'GRID',
        GROUPSELECT: 'GROUPSELECT',
        REGIONSELECT: 'REGIONSELECT',
        DOWNLOAD: 'DOWNLOAD',
        UPLOAD: 'FILE',
        DATE: 'DATE',
        DATETIME: 'DATETIME',
        CUSTOMGRID: 'CUSTOMGRID',
        UPLOADV2: 'UPLOADV2'
    },

};


PJQ.constants.projects = {
    customFields: {
        fieldTypes: [
            PJQ.constants.customFields.fieldTypes.INT,
            PJQ.constants.customFields.fieldTypes.PERCENT,
            PJQ.constants.customFields.fieldTypes.MONEY,
            PJQ.constants.customFields.fieldTypes.TEXT,
            PJQ.constants.customFields.fieldTypes.TEXTAREA,
            PJQ.constants.customFields.fieldTypes.BOOL,
            PJQ.constants.customFields.fieldTypes.CHOICE,
            PJQ.constants.customFields.fieldTypes.DATE,
            PJQ.constants.customFields.fieldTypes.DATETIME
        ]
    }
};

PJQ.constants.ordering = {
    paperSize: {
        FULL: 'FULL SIZE',
        HALF: 'HALF SIZE'
    },
    paper: {
        WHITE: 'WHITE BOND',
        BLUE: 'BLUE BOND',
        GREEN: 'GREEN BOND',
        YELLOW: 'YELLOW BOND',
        PINK: 'PINK BOND'
    },
    largeBinding: {
        STAPLED: 'STAPLED',
        LOOSE: 'LOOSE',
        EDGE: 'BINDING EDGE',
        PUNCHBIND: 'PUNCH AND BIND'
    },
    smallBinding: {
        STAPLED: 'STAPLED',
        LOOSE: 'LOOSE',
        CHICAGO: 'CHICAGO SCREW',
        GBC: 'GBC PLASTIC COMB'
    },
    deliveryOptions: {
        NEXTMORNING: 'Next Day (Morning)',
        NEXTDAY: 'Next Day (Standard)',
        TWODAY: 'Two Day',
        THREEDAY: 'Three Day'
    }
};

PJQ.constants.general = {
    defaultView: {
        COMPANY: 'View by Company',
        MESSAGE: 'View by Message',
        RESPONSE: 'View by Response',
        GROUPS: 'View by Groups',
        SCOPE: 'View by Scope'
    },
    defaultTimeZone: {
        ALASKAN: 'Alaskan',
        ATLANTIC: 'Atlantic',
        CENTRAL: 'Central',
        EASTERN: 'Eastern',
        HAWAIIAN: 'Hawaiian',
        MOUNTAIN: 'Mountain',
        PACIFIC: 'Pacific'
    }
};

PJQ.constants.time = {
    millis: {
        ONE_SECOND: 1000,
        ONE_MINUTE: 60000,
        ONE_HOUR: 3600000,
        ONE_DAY: 86400000,
        ONE_MONTH: 2592000000,
        ONE_YEAR: 31556952000
    }
};

PJQ.constants.files = {
    modes: {
        PRINT: 'print',
        ALT_PRINT: 'altprint',
        DOWNLOAD: 'download'
    },
    zipStatus: {
        NEW: 0,
        QUEUED: 1,
        IN_PROGRESS: 2,
        CANCELLED: 3,
        FAILED: 4,
        COMPLETE: 5,
        COMPLETE_ASYNC: 6
    },
    downloadFrameId: 'pjqDownload',
    imageExtensions: ['jpg', 'jpeg', 'png', 'bmp', 'gif']
};

PJQ.constants.actionItems = {
    notificationTypeNames: {
        NEW_ITEM: 'Item Created',
        STATUS_CHANGE: 'Status Changed',
        ASSIGNED: 'Assigned',
        NEWCOMMENT: 'Comment Added',
        DISTRIBUTE: 'Distribution'
    },
    statuses: {
        NEW: 0,
        ASSIGNED: 4,
        WORK_COMPLETED: 2,
        NOT_RESOLVED: 1,
        RESOLVED: 3
    },
    statusNames: {
        0: 'New',
        1: 'Not Resolved',
        2: 'Work Completed',
        3: 'Resolved',
        4: 'Assigned'
    },
    statusColors: {
        0: PJQ.constants.colors.GRAY,
        1: PJQ.constants.colors.RED,
        2: PJQ.constants.colors.BLUE,
        3: PJQ.constants.colors.GREEN,
        4: PJQ.constants.colors.PURPLE
    },
    priorities: {
        LOW: 0,
        MEDIUM: 1,
        HIGH: 2,
        CRITICAL: 3
    },
    priorityNames: {
        0: 'Low',
        1: 'Medium',
        2: 'High',
        3: 'Critical',
    },
    priorityColors: {
        0: PJQ.constants.colors.GREEN,
        1: PJQ.constants.colors.YELLOW,
        2: PJQ.constants.colors.ORANGE,
        3: PJQ.constants.colors.RED
    },
    view: {
        ACTIONITEMS: "actionitems"
    }
};

PJQ.constants.dailyReports = {
    statuses: {
        NOT_SUBMITTED: 0,
        SUBMITTED: 1,
        DAY_OFF: 2,
        MISSED: 3
    },
    statusNames: {
        0: 'Not Submitted',
        1: 'Submitted',
        2: 'Day Off',
        3: 'Missed'
    },
    notificationModes: {
        DEFAULT: 1,
        PER_USER_DAY: 2,
        DISABLED: 3
    },
    communicationLogs: {
        types: {
            PHONE: 0,
            TEXT: 1,
            EMAIL: 2,
            IN_PERSON: 3,
            CONFERENCE_CALL: 4,
            WEB_CONFERENCE: 5
        },
        typeNames: {
            0: "Phone Call",
            1: "Text Message",
            2: "Email",
            3: "In Person",
            4: "Conference Call",
            5: "Web Conference"
        }
    },
    inspectionLogs: {
        statuses: {
            REJECTED: 0,
            APPROVED: 1
        },
        statusNames: {
            0: "Rejected",
            1: "Approved"
        }
    }
};

PJQ.constants.meetings = {
    meetingStatus: {
        DRAFT: 1,
        SCHEDULED: 2,
        IN_PROGRESS: 3,
        CONCLUDED: 4,
        CANCELLED: 5
    },
    meetingStatusNames: {
        1: 'Draft',
        2: 'Scheduled',
        3: 'In Progress',
        4: 'Concluded',
        5: 'Cancelled'
    },
    meetingAgendaStatus: {
        OPEN: 1,
        CLOSED: 2,
        HALTED: 3
    },
    meetingAgendaStatusNames: {
        1: 'Open',
        2: 'Closed',
        3: 'Halted'
    },
    meetingAgendaStatusColors: {
        1: PJQ.constants.colors.GREEN,
        2: PJQ.constants.colors.RED,
        3: PJQ.constants.colors.DARK
    },
    meetingAgendaPriority: {
        LOW: 1,
        MEDIUM: 2,
        HIGH: 3,
        URGENT: 4
    },
    meetingAgendaPriorityNames: {
        1: 'Low',
        2: 'Medium',
        3: 'High',
        4: 'Urgent'
    },
    meetingAgendaPriorityColors: {
        1: PJQ.constants.colors.GREEN,
        2: PJQ.constants.colors.YELLOW,
        3: PJQ.constants.colors.RED,
        4: PJQ.constants.colors.DARK
    }
}

PJQ.constants.punchlists = {
    notificationTypeNames: {
        NEW_ITEM: 'Item Created',
        STATUS_CHANGE: 'Status Changed',
        ASSIGNED: 'Assigned',
        NEWCOMMENT: 'Comment Added',
        DISTRIBUTE: 'Distribution'
    },
    statuses: {
        NEW: 0,
        NOT_RESOLVED: 1,
        WORK_COMPLETED: 2,
        RESOLVED: 3,
        ASSIGNED: 4
    },
    statusNames: {
        0: 'New',
        1: 'Not Resolved',
        2: 'Work Completed',
        3: 'Resolved',
        4: 'Assigned'
    },
    statusColors: {
        0: PJQ.constants.colors.GRAY,
        1: PJQ.constants.colors.RED,
        2: PJQ.constants.colors.BLUE,
        3: PJQ.constants.colors.GREEN,
        4: PJQ.constants.colors.PURPLE
    },
    priorities: {
        LOW: 0,
        MEDIUM: 1,
        HIGH: 2,
        CRITICAL: 3
    },
    priorityNames: {
        0: 'Low',
        1: 'Medium',
        2: 'High',
        3: 'Critical',
    },
    priorityColors: {
        0: PJQ.constants.colors.GREEN,
        1: PJQ.constants.colors.YELLOW,
        2: PJQ.constants.colors.ORANGE,
        3: PJQ.constants.colors.RED
    },
    view: {
        PUNCHLISTS: "punchlists"
    }
};

PJQ.constants.rfi = {
    notificationTypeNames: {
        NEW_ITEM: 'Item Opened',
        RFIOpen: 'Item Opened',
        RFIUpdateDueDate: 'Due Date Updated',
        RFIAddDocument: 'Document Added',
        RFIAddAssignee: 'Assignee Added',
        RFIAddDistribution: 'Dist. Contact Added',
        RFIAddResponse: 'Response Added',
        RFIClose: 'Item Closed',
        Overdue: 'Overdue'
    },
    statuses: {
        DRAFT: 0,
        OPEN: 1,
        CLOSED: 2,
        DISTRIBUTED: 3
    },
    statusNames: {
        0: 'Draft',
        1: 'Open',
        2: 'Closed',
        3: 'Distributed'
    },
    statusColors: {
        0: PJQ.constants.colors.GRAY,
        1: PJQ.constants.colors.GREEN,
        2: PJQ.constants.colors.RED,
        3: PJQ.constants.colors.PURPLE
    },
    view: {
        RFIS: "rfis"
    }
};

PJQ.constants.submittals = {
    notificationTypeNames: {
        Created: 'Created',
        Attachment: 'Attachment',
        Comment: 'Comment',
        BallInCourt: 'Ball In Court',
        'Ball In Court': 'Ball In Court',
        Approved: 'Approved',
        'File(s) Uploaded': 'File(s) Uploaded',
        Rejected: 'Rejected',
        Submitted: 'Submitted',
        Assigned: 'Assigned',
        Overdue: 'Overdue',
        Distribute: 'Distribution'
    },
    errors: {
        STATUS_NOT_EXISTS: 'STATUS_NOT_EXISTS'
    },
    approvalModes: {
        UNORDERED: 1,
        SEQUENTIAL: 2
    },
    statusTypeColors: {
        0: PJQ.constants.colors.GRAY,
        1: PJQ.constants.colors.BLUE,
        2: PJQ.constants.colors.GREEN,
        3: PJQ.constants.colors.RED,
        4: PJQ.constants.colors.DARK
    },
    statusTypes: {
        NEW: 0,
        SUBMITTED: 1,
        APPROVED: 2,
        REJECTED: 3,
        VOID: 4
    },
    statusTypeNames: {
        0: 'New',
        1: 'Submitted',
        2: 'Approved',
        3: 'Rejected',
        4: 'Void'
    },
    view: {
        SUBMITTALS: 'submittals'
    }
};

PJQ.constants.schedule = {
    notificationTypeNames: {
        ASSIGNED: 'Assigned',
        SCHEDULE_CHANGE: 'Schedule Changed',
        REMINDER: 'Reminder',
        COMMENT_ADDED: 'Comment Added',
        ATTACHMENT_ADDED: 'Attachment Added',
        TASK_COMPLETE: 'Task Complete',
        SCHEDULE_UPDATE: 'Schedule Update'
    },
    dependencyTypes: {
        START_START: 'SS',
        FINISH_START: 'FS'
    },
    linkTypes: {
        0: 'FS',
        1: 'SS',
        2: 'FF',
        3: 'SF'
    },
    views: {
        TIMELINE: 'TIMELINE',
        CALENDAR: 'CALENDAR',
        TASK_LIST: 'TASK_LIST'
    },
    taskList: {
        groupBy: {
            DEFAULT: 'DEFAULT',
            MONTH: 'MONTH',
            WEEK: 'WEEK',
            DAY: 'DAY',
            ASSIGNEE: 'ASSIGNEE',
            GROUP: 'GROUP'
        }
    }
};

PJQ.constants.proQual = {
    screeningStatuses: {
        Pending: 1,
        Declined: 2,
        InProcess: 3,
        Incomplete: 4,
        FeedbackRequired: 5,
        Expired: 6,
        Complete: 7,
        NotApplicable: 8
    }
};